(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advanced-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SEARCH_THRESHOLD = 12;

  function AdvancedSearch(root) {
    this.root = root;
    this.endpoint = root.dataset.endpoint;
    this.searchUrl = root.dataset.searchUrl || '/search';
    this.i18n = {
      optionsSearch: root.dataset.i18nOptionsSearch,
      from: root.dataset.i18nPriceFrom,
      to: root.dataset.i18nPriceTo
    };

    this.els = {
      loading: root.querySelector('[data-adv-loading]'),
      error: root.querySelector('[data-adv-error]'),
      form: root.querySelector('[data-adv-form]'),
      gameStep: root.querySelector('[data-adv-game-step]'),
      gameGrid: root.querySelector('[data-adv-game-grid]'),
      shared: root.querySelector('[data-adv-shared]'),
      gameFields: root.querySelector('[data-adv-games-fields]'),
      clear: root.querySelector('[data-adv-clear]')
    };

    this.schema = null;
    this.games = []; // [] means no game restriction

    this.init();
  }

  AdvancedSearch.prototype.init = function () {
    var self = this;

    this.els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit();
    });
    this.els.clear.addEventListener('click', function () {
      self.games = [];
      self.render();
    });

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 5000);

    fetch(this.endpoint, { headers: { Accept: 'application/json' }, signal: controller.signal })
      .then(function (r) {
        clearTimeout(timeout);
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (schema) {
        if (schema.success === false) throw new Error('schema unavailable');
        self.schema = schema;
        self.els.loading.hidden = true;
        self.els.form.hidden = false;
        self.render();
      })
      .catch(function (err) {
        console.error('[AdvancedSearch]', err);
        self.els.loading.hidden = true;
        self.els.error.hidden = false;
      });
  };

  AdvancedSearch.prototype.render = function () {
    this.renderGames();
    this.renderShared();
    this.renderGameFields();
  };

  AdvancedSearch.prototype.renderGames = function () {
    var self = this;
    var games = this.schema.games || [];

    this.els.gameStep.hidden = games.length === 0;
    this.els.gameGrid.innerHTML = '';

    games.forEach(function (game) {
      var label = document.createElement('label');
      label.className = 'advanced-search__game';

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.value = game.code;
      input.checked = self.games.indexOf(game.code) !== -1;
      input.addEventListener('change', function () {
        if (input.checked) {
          if (self.games.indexOf(game.code) === -1) self.games.push(game.code);
        } else {
          self.games = self.games.filter(function (c) { return c !== game.code; });
        }
        // Not render(): re-rendering the shared block would wipe what the shopper typed.
        self.renderGameFields();
      });

      var span = document.createElement('span');
      span.textContent = game.name;

      label.appendChild(input);
      label.appendChild(span);
      self.els.gameGrid.appendChild(label);
    });
  };

  AdvancedSearch.prototype.renderShared = function () {
    var self = this;
    this.els.shared.innerHTML = '';

    (this.schema.shared_fields || []).forEach(function (field) {
      var el = self.buildField(field, null);
      if (el) self.els.shared.appendChild(el);
    });
  };

  AdvancedSearch.prototype.renderGameFields = function () {
    var self = this;
    var byGame = this.schema.game_fields || {};
    var names = {};
    (this.schema.games || []).forEach(function (g) { names[g.code] = g.name; });

    this.els.gameFields.innerHTML = '';

    this.games.forEach(function (code) {
      var fields = byGame[code] || [];
      if (!fields.length) return;

      var block = document.createElement('section');
      block.className = 'advanced-search__game-block';
      block.dataset.advGame = code;

      var title = document.createElement('h2');
      title.className = 'advanced-search__game-title';
      title.textContent = names[code] || code.toUpperCase();
      block.appendChild(title);

      var list = document.createElement('div');
      list.className = 'advanced-search__fields';
      fields.forEach(function (field) {
        var el = self.buildField(field, code);
        if (el) list.appendChild(el);
      });

      block.appendChild(list);
      self.els.gameFields.appendChild(block);
    });
  };

  AdvancedSearch.prototype.buildField = function (field, game) {
    var wrap = document.createElement('div');
    wrap.className = 'adv-field adv-field--' + field.control;
    wrap.setAttribute('data-adv-field', '');
    wrap.dataset.key = field.key;
    wrap.dataset.control = field.control;
    if (game) wrap.dataset.game = game;
    if (field.stock_sensitive) wrap.dataset.stockSensitive = 'true';

    switch (field.control) {
      case 'text': this.buildText(wrap, field); break;
      case 'toggle': this.buildToggle(wrap, field); break;
      case 'range': this.buildRange(wrap, field); break;
      case 'multi_select': return this.buildMultiSelect(wrap, field) ? wrap : null;
      default: return null;
    }
    return wrap;
  };

  AdvancedSearch.prototype.label = function (text, forId) {
    var label = document.createElement('label');
    label.className = 'adv-field__label';
    label.textContent = text;
    if (forId) label.setAttribute('for', forId);
    return label;
  };

  AdvancedSearch.prototype.buildText = function (wrap, field) {
    var id = 'adv-' + (wrap.dataset.game ? wrap.dataset.game + '-' : '') + field.key;
    wrap.appendChild(this.label(field.label, id));

    var input = document.createElement('input');
    input.type = 'text';
    input.id = id;
    input.className = 'adv-field__input';
    input.setAttribute('data-adv-input', '');
    wrap.appendChild(input);
  };

  AdvancedSearch.prototype.buildToggle = function (wrap, field) {
    var label = document.createElement('label');
    label.className = 'adv-field__toggle';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('data-adv-toggle', '');
    input.checked = field.default_on !== false;

    var span = document.createElement('span');
    span.textContent = field.label;

    label.appendChild(input);
    label.appendChild(span);
    wrap.appendChild(label);
  };

  AdvancedSearch.prototype.buildRange = function (wrap, field) {
    var self = this;
    var text = field.currency ? field.label + ' (' + field.currency.toUpperCase() + ')' : field.label;
    wrap.appendChild(this.label(text));

    var row = document.createElement('div');
    row.className = 'adv-field__range';

    // Price bounds arrive in cents; stat bounds are plain numbers.
    var isPrice = field.key === 'price';
    var bounds = field.values || {};

    function group(labelText, marker) {
      var g = document.createElement('div');
      g.className = 'adv-field__range-group';

      var l = document.createElement('span');
      l.className = 'adv-field__range-label';
      l.textContent = labelText;

      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'adv-field__number';
      input.setAttribute(marker, '');
      input.min = '0';
      if (isPrice) {
        input.step = '0.01';
        input.inputMode = 'decimal';
        if (bounds.min != null) input.placeholder = (bounds.min / 100).toFixed(2);
        if (bounds.max != null && marker === 'data-adv-max') input.placeholder = (bounds.max / 100).toFixed(2);
      } else {
        input.step = '1';
        input.inputMode = 'numeric';
      }

      g.appendChild(l);
      g.appendChild(input);
      return g;
    }

    row.appendChild(group(self.i18n.from, 'data-adv-min'));
    row.appendChild(group(self.i18n.to, 'data-adv-max'));
    wrap.appendChild(row);
  };

  // count === 0 means the store carries none, so drop it. A missing count (format
  // legality, which isn't counted) is not a zero and must still be offered.
  AdvancedSearch.prototype.buildMultiSelect = function (wrap, field) {
    var options = (field.values || []).filter(function (v) { return v.count !== 0; });
    if (!options.length) return false;

    wrap.appendChild(this.label(field.label));

    var list = document.createElement('div');
    list.className = 'adv-field__options';

    if (options.length > SEARCH_THRESHOLD) {
      var search = document.createElement('input');
      search.type = 'text';
      search.className = 'adv-field__search';
      search.placeholder = this.i18n.optionsSearch;
      search.autocomplete = 'off';
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        list.querySelectorAll('.adv-field__option').forEach(function (option) {
          var hit = q === '' || (option.dataset.label || '').indexOf(q) !== -1;
          option.classList.toggle('is-hidden', !hit);
        });
      });
      wrap.appendChild(search);
    }

    options.forEach(function (option) {
      var label = document.createElement('label');
      label.className = 'adv-field__option';
      label.dataset.label = String(option.label).toLowerCase();

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('data-adv-value', '');
      input.value = option.value;

      var span = document.createElement('span');
      span.textContent = option.label;

      label.appendChild(input);
      label.appendChild(span);
      list.appendChild(label);
    });

    wrap.appendChild(list);
    return true;
  };

  AdvancedSearch.prototype.submit = function () {
    var url = new URL(this.searchUrl, window.location.origin);
    var inStock = this.inStockChecked();

    if (this.games.length) url.searchParams.set('games', this.games.join(','));

    var self = this;
    this.root.querySelectorAll('[data-adv-field]').forEach(function (wrap) {
      self.appendField(url, wrap, inStock);
    });

    // The API defaults to in-stock only, so only the unchecked state needs saying.
    if (!inStock) url.searchParams.set('filter.v.availability', '0,1');

    window.location.assign(url.toString());
  };

  AdvancedSearch.prototype.inStockChecked = function () {
    var toggle = this.root.querySelector('[data-adv-field][data-control="toggle"] [data-adv-toggle]');
    return toggle ? toggle.checked : true;
  };

  AdvancedSearch.prototype.appendField = function (url, wrap, inStock) {
    var key = wrap.dataset.key;
    var game = wrap.dataset.game;
    var control = wrap.dataset.control;

    if (control === 'toggle') return; // handled once, in submit()

    if (control === 'text') {
      var value = wrap.querySelector('[data-adv-input]').value.trim();
      if (!value) return;
      url.searchParams.set(game ? game + '.' + key : key, value);
      return;
    }

    if (control === 'range') {
      var min = wrap.querySelector('[data-adv-min]').value;
      var max = wrap.querySelector('[data-adv-max]').value;

      if (key === 'price') {
        // filter.v.price.* is Shopify's own vocabulary, so the search sidebar reads it back.
        if (min !== '') url.searchParams.set('filter.v.price.gte', min);
        if (max !== '') url.searchParams.set('filter.v.price.lte', max);
      } else {
        if (min !== '') url.searchParams.set(game + '.' + key + '_min', min);
        if (max !== '') url.searchParams.set(game + '.' + key + '_max', max);
      }
      return;
    }

    if (control === 'multi_select') {
      var values = [];
      wrap.querySelectorAll('[data-adv-value]:checked').forEach(function (box) {
        values.push(box.value);
      });
      if (!values.length) return;

      if (game) {
        url.searchParams.set(game + '.' + key, values.join(','));
        return;
      }

      // Shared facets ride as filter.p.tag so the search sidebar reads them back ticked.
      // Stock-sensitive ones (condition, finish) count over inventory, so in the in-stock
      // view they take the `instock.` tag family. Must match the sidebar's rule (SID-373).
      var prefix = (wrap.dataset.stockSensitive === 'true' && inStock) ? 'instock.' : '';
      values.forEach(function (value) {
        url.searchParams.append('filter.p.tag', prefix + key + ':' + value);
      });
    }
  };

  document.querySelectorAll('[data-advanced-search]').forEach(function (root) {
    new AdvancedSearch(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const bar = document.querySelector('[id^="announcement-bar-"]');
    if (!bar) return;

    const storageKey = 'sideboard-announcement-dismissed-' + bar.id;

    // Check if already dismissed in this session
    if (sessionStorage.getItem(storageKey) === 'true') {
      bar.hidden = true;
      return;
    }

    // Dismiss button functionality
    const dismissBtn = bar.querySelector('[data-announcement-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function() {
        bar.hidden = true;
        sessionStorage.setItem(storageKey, 'true');
      });
    }

    // Marquee fill functionality
    // Liquid always renders 4 copies of the message, which isn't enough to cover
    // wide viewports; clone copies until the track is >= 2x the wrapper width and
    // scale the animation duration so the scroll speed (px/s) stays constant.
    const track = bar.querySelector('.announcement-bar__marquee-track');
    if (track && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const wrapper = track.parentElement;
      const baseDuration = parseFloat(getComputedStyle(bar).getPropertyValue('--marquee-duration')) || 20;
      const baseCount = track.children.length;

      function fillMarquee() {
        const first = track.children[0];
        if (!first || first.getBoundingClientRect().width === 0) return;

        const itemWidth = first.getBoundingClientRect().width;
        let needed = Math.ceil((wrapper.clientWidth * 2) / itemWidth) + 2;
        if (needed % 2 !== 0) needed += 1;
        needed = Math.max(needed, baseCount);

        while (track.children.length < needed) {
          const clone = first.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        track.style.animationDuration = (baseDuration * track.children.length / baseCount) + 's';
      }

      fillMarquee();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fillMarquee);
      }

      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(fillMarquee, 150);
      });
    }

    // Countdown timer functionality
    const countdownDate = bar.dataset.countdownDate;
    if (countdownDate) {
      const countdownContainer = bar.querySelector('[data-countdown]');
      const hideOnExpire = bar.dataset.hideOnExpire === 'true';
      let countdownInterval;

      // Get translation strings from data attributes
      const translations = {
        endsNow: countdownContainer?.dataset.textEndsNow || 'Ends now!',
        endsToday: countdownContainer?.dataset.textEndsToday || 'Ends today!',
        day: countdownContainer?.dataset.textDay || 'day',
        days: countdownContainer?.dataset.textDays || 'days',
        hour: countdownContainer?.dataset.textHour || 'hour',
        hours: countdownContainer?.dataset.textHours || 'hours',
        min: countdownContainer?.dataset.textMin || 'min',
        mins: countdownContainer?.dataset.textMins || 'mins',
        left: countdownContainer?.dataset.textLeft || 'left'
      };

      function parseCountdownDate(dateStr) {
        // Expected format: YYYY-MM-DD HH:MM
        const [datePart, timePart] = dateStr.trim().split(' ');
        if (!datePart) return null;

        const [year, month, day] = datePart.split('-').map(Number);
        let hours = 0, minutes = 0;

        if (timePart) {
          const [h, m] = timePart.split(':').map(Number);
          hours = h || 0;
          minutes = m || 0;
        }

        return new Date(year, month - 1, day, hours, minutes);
      }

      function updateCountdown() {
        const countdownElements = bar.querySelectorAll('[data-countdown-text]');
        const endDate = parseCountdownDate(countdownDate);
        if (!endDate || isNaN(endDate.getTime())) {
          countdownElements.forEach(function(el) {
            el.textContent = '';
          });
          return;
        }

        const now = new Date();
        const diff = endDate - now;

        if (diff <= 0) {
          // Countdown expired
          if (hideOnExpire) {
            bar.hidden = true;
          } else {
            countdownElements.forEach(function(el) {
              el.closest('[data-countdown]').classList.add('announcement-bar__countdown--expired');
            });
          }
          if (countdownInterval) {
            clearInterval(countdownInterval);
          }
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        let text;
        if (days === 0 && hours === 0 && minutes === 0) {
          text = translations.endsNow;
        } else if (days === 0 && hours < 24) {
          // Less than 24 hours remaining
          if (hours === 0) {
            text = minutes + ' ' + (minutes !== 1 ? translations.mins : translations.min) + ' ' + translations.left;
          } else {
            text = translations.endsToday + ' ' + hours + 'h ' + minutes + 'm';
          }
        } else {
          // Build countdown string
          const parts = [];
          if (days > 0) {
            parts.push(days + ' ' + (days !== 1 ? translations.days : translations.day));
          }
          if (hours > 0) {
            parts.push(hours + ' ' + (hours !== 1 ? translations.hours : translations.hour));
          }
          if (minutes > 0 && days < 7) {
            parts.push(minutes + ' ' + (minutes !== 1 ? translations.mins : translations.min));
          }
          text = parts.join(' ');
        }

        countdownElements.forEach(function(el) {
          el.textContent = text;
        });
      }

      // Initial update
      updateCountdown();

      // Update every minute
      countdownInterval = setInterval(updateCountdown, 60000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ================================================================
     FIXTURE DATA  (post-hydrate render shape: card + grouped printings)
     Used when section setting 'use_demo_data' == true  OR
     URL contains ?bulk_fixture=1. Mirrors what hydrateRow() produces so
     the builder UI works before the backend endpoint is live.
  ================================================================ */
  var BULK_SEARCH_FIXTURE = {
    "success": true,
    "currency": "CAD",
    "results": [
      {
        "raw": "4 Lightning Bolt",
        "status": "found",
        "requested_qty": 4,
        "card": {
          "name": "Lightning Bolt",
          "image_url": "https://cards.scryfall.io/normal/front/e/3/e3285e6b-3e79-4d7c-bf96-d920f973b122.jpg"
        },
        "printings": [
          {
            "handle": "lightning-bolt-m10",
            "set_name": "Magic 2010", "set_code": "M10", "collector_number": "146",
            "image_url": "https://cards.scryfall.io/normal/front/e/3/e3285e6b-3e79-4d7c-bf96-d920f973b122.jpg",
            "title": "Lightning Bolt",
            "variants": [
              { "shopify_variant_id": 44883920, "condition": "near_mint",      "finish": "normal", "price": 599,  "available_qty": 7 },
              { "shopify_variant_id": 44883921, "condition": "lightly_played", "finish": "normal", "price": 499,  "available_qty": 2 },
              { "shopify_variant_id": 44883922, "condition": "near_mint",      "finish": "foil",   "price": 1899, "available_qty": 1 }
            ]
          },
          {
            "handle": "lightning-bolt-beatdown",
            "set_name": "Beatdown Box Set", "set_code": "BTD", "collector_number": "59",
            "image_url": "",
            "title": "Lightning Bolt",
            "variants": [
              { "shopify_variant_id": 44883930, "condition": "near_mint",      "finish": "normal", "price": 525, "available_qty": 3 },
              { "shopify_variant_id": 44883931, "condition": "lightly_played", "finish": "normal", "price": 450, "available_qty": 4 }
            ]
          }
        ]
      },
      {
        "raw": "1 Sol Ring",
        "status": "found",
        "requested_qty": 1,
        "card": { "name": "Sol Ring", "image_url": "" },
        "printings": [
          {
            "handle": "sol-ring-c21",
            "set_name": "Commander 2021", "set_code": "C21", "collector_number": "263",
            "image_url": "", "title": "Sol Ring",
            "variants": [
              { "shopify_variant_id": 44884000, "condition": "near_mint", "finish": "normal", "price": 250, "available_qty": 12 }
            ]
          }
        ]
      },
      {
        "raw": "1 Mana Crypt",
        "status": "no_stock",
        "requested_qty": 1,
        "card": { "name": "Mana Crypt", "image_url": "" },
        "printings": []
      },
      {
        "raw": "2 Lighning Bolt",
        "status": "not_found",
        "requested_qty": 2,
        "card": null,
        "printings": []
      }
    ],
    "summary": { "found": 2, "no_stock": 1, "not_found": 1 }
  };

  /* ================================================================
     HELPERS
  ================================================================ */

  /* Currency code from the last resolve response — populated by _renderResults */
  var _resolvedCurrency = null;

  /* Merchant-chosen default price sort for the auto-built selection.
     'low_to_high' (default) auto-fills the cheapest in-stock variant first;
     'high_to_low' fills the most expensive first. Set per-init from the
     section's data-price-sort. Not buyer-facing — it only seeds defaults and
     variant ordering; buyers can still adjust each stepper. */
  var _priceSortDir = 'low_to_high';

  function formatMoney(cents) {
    /* Guard: null/undefined price must not produce NaN */
    if (cents == null || isNaN(cents)) return '';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    /* Fallback: use resolved currency from §3 response, then Shopify.currency, then nothing */
    var code = _resolvedCurrency
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || '';
    var amount = (cents / 100).toFixed(2);
    return code ? code + ' ' + amount : amount;
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function t(key, vars) {
    /* Lean i18n shim that reads from window.Sideboard.i18n if present,
       otherwise returns a reasonable English fallback. */
    var translations = (window.Sideboard && window.Sideboard.i18n && window.Sideboard.i18n.bulk_search) || {};
    var parts = key.split('.');
    var val = translations;
    for (var i = 0; i < parts.length; i++) {
      val = val && val[parts[i]];
    }
    if (typeof val !== 'string') {
      /* Fallbacks keyed to the translation table in en.default.json */
      var FALLBACKS = {
        'buckets.found':          'Found',
        'buckets.other_printing': 'Other Printing',
        'buckets.no_stock':       'No Stock',
        'buckets.not_found':      'Not Found',
        'condition.near_mint':    'NM',
        'condition.lightly_played': 'LP',
        'condition.moderately_played': 'MP',
        'condition.heavily_played': 'HP',
        'condition.damaged':      'DMG',
        'status.in_stock':        'in stock',
        'status.no_stock':        'No stock',
        'status.not_found':       'Not found',
        'status.sold_out':        'Sold out',
        'add_button':             'Add',
        'add_all_button':         'Add all available',
        'back_button':            'Back to search',
        'added_label':            'Added',
        'sold_out_label':         'Sold out',
        'partial_add_notice':     'Some items could not be added.',
        'suggestions_label':      'Did you mean:',
        'total_label':            'Total:',
        'demo_notice':            'Demo mode — using fixture data',
        'fill_counter':           '%{queued}/%{requested}',
        'summary_found':          '%{count} of %{total} cards found',
        'no_stock_message':       'We carry this — out of stock right now',
        'not_found_message':      'We couldn\'t find this card',
        'none_selected':          'None selected',
        'mixed_selection':        '%{count} printings',
        'unknown_printing':       'Printing',
        'decrease_qty':           'Decrease quantity',
        'increase_qty':           'Increase quantity',
        'results_announce':       'Found %{count} of %{total} cards',
        'added_announce':         '%{added} added to cart',
        'added_announce_partial': '%{added} added to cart, %{failed} sold out',
        'resolve_button':         'Resolve list',
        'clear_button':           'Clear',
        'heading':                'Bulk Card Search',
        'textarea_label':         'Paste your list',
        'textarea_placeholder':   '4 Lightning Bolt (M10) 146 *F*\n1 Sol Ring\n2 Mox Opal (SOM)',
        'textarea_hint':          'One card per line. Supports MTG, Pokémon, Yu-Gi-Oh!, Lorcana, One Piece, and more.',
      };
      val = FALLBACKS[key] || key;
    }
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        val = val.replace('%{' + k + '}', vars[k]);
      });
    }
    return val;
  }

  /* Condition label → abbreviation */
  function conditionAbbrev(condition) {
    var MAP = {
      'near_mint':          'NM',
      'lightly_played':     'LP',
      'moderately_played':  'MP',
      'heavily_played':     'HP',
      'damaged':            'DMG',
    };
    return MAP[condition] || condition;
  }

  /* ================================================================
     CARD + BUILDER
     A "found" result renders as a collapsible card: a clickable head
     (image, name, live summary + fill counter + subtotal) over an
     expandable builder where every printing is grouped and each
     printing's in-stock variants are stepper rows — so the buyer
     composes a mix across printings/conditions toward the requested
     quantity. no_stock / not_found render as a plain, non-interactive
     head with status copy.
  ================================================================ */

  var _cardSeq = 0;

  function placeholderSvg() {
    return '<svg width="28" height="28" viewBox="0 0 48 48" fill="none" aria-hidden="true"><rect width="48" height="48" rx="4" fill="currentColor" opacity="0.1"/><path d="M18 30L24 24L30 30" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/></svg>';
  }

  function imageEl(url, cls) {
    var wrap = document.createElement('div');
    wrap.className = cls;
    if (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.loading = 'lazy';
      img.className = cls + '-img';
      wrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = cls + '-placeholder';
      ph.innerHTML = placeholderSvg();
      wrap.appendChild(ph);
    }
    return wrap;
  }

  function variantLabel(v) {
    var label = conditionAbbrev(v.condition);
    if (v.finish && v.finish !== 'normal') label += ' • ' + v.finish;
    return label;
  }

  /* Prefer the backend's catalog set label; fall back to the product title. */
  function printingLabel(printing) {
    var parts = [];
    if (printing.set_name) {
      parts.push(printing.set_code
        ? printing.set_name + ' (' + String(printing.set_code).toUpperCase() + ')'
        : printing.set_name);
    } else if (printing.title) {
      parts.push(printing.title);
    }
    if (printing.collector_number) parts.push('#' + printing.collector_number);
    return parts.join(' · ');
  }

  /* Every in-stock variant across a card's printings, sorted by the merchant's
     price-sort setting (condition breaks price ties), so we can pick a sensible
     default and total things up. */
  function allVariants(result) {
    var out = [];
    (result.printings || []).forEach(function (pr) {
      (pr.variants || []).forEach(function (v) {
        if (v.available_qty > 0) out.push(v);
      });
    });
    out.sort(comparePrice);
    return out;
  }

  /* ── A single variant stepper row (0 = not included) ── */
  function buildVariant(v, defaultQty) {
    var row = document.createElement('div');
    row.className = 'bulk-search-variant';
    row.dataset.bsVariant = '';
    row.dataset.variantId = v.shopify_variant_id;
    row.dataset.price = v.price;
    row.dataset.available = v.available_qty;

    var label = document.createElement('span');
    label.className = 'bulk-search-variant__label';
    label.textContent = variantLabel(v);
    row.appendChild(label);

    var price = document.createElement('span');
    price.className = 'bulk-search-variant__price';
    price.textContent = formatMoney(v.price);
    row.appendChild(price);

    var stock = document.createElement('span');
    stock.className = 'bulk-search-variant__stock';
    if (v.available_qty <= 10) stock.textContent = v.available_qty + ' ' + t('status.in_stock');
    row.appendChild(stock);

    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'bulk-search-variant__qty';

    var dec = document.createElement('button');
    dec.type = 'button';
    dec.className = 'bulk-search-variant__qty-btn';
    dec.textContent = '−';
    dec.setAttribute('aria-label', t('decrease_qty'));

    var input = document.createElement('input');
    input.type = 'number';
    input.className = 'bulk-search-variant__qty-input';
    input.dataset.bsVariantQty = '';
    input.min = '0';
    input.max = String(v.available_qty);
    input.value = String(Math.max(0, Math.min(defaultQty || 0, v.available_qty)));
    input.setAttribute('aria-label', variantLabel(v) + ' ' + formatMoney(v.price));

    var inc = document.createElement('button');
    inc.type = 'button';
    inc.className = 'bulk-search-variant__qty-btn';
    inc.textContent = '+';
    inc.setAttribute('aria-label', t('increase_qty'));

    function clamp() {
      var max = parseInt(input.max, 10) || 0;
      input.value = String(Math.max(0, Math.min(max, parseInt(input.value, 10) || 0)));
    }
    function changed() {
      clamp();
      row.dispatchEvent(new CustomEvent('bulksearch:rowchange', { bubbles: true }));
    }
    dec.addEventListener('click', function () {
      input.value = String(Math.max(0, (parseInt(input.value, 10) || 0) - 1));
      changed();
    });
    inc.addEventListener('click', function () {
      var max = parseInt(input.max, 10) || 0;
      input.value = String(Math.min(max, (parseInt(input.value, 10) || 0) + 1));
      changed();
    });
    input.addEventListener('change', changed);

    qtyWrap.appendChild(dec);
    qtyWrap.appendChild(input);
    qtyWrap.appendChild(inc);
    row.appendChild(qtyWrap);

    return row;
  }

  /* ── One printing group: header (set label + image) + its variant rows.
     defaultQtyById maps shopify_variant_id → starting qty from the cascade. ── */
  function buildPrinting(printing, defaultQtyById) {
    var group = document.createElement('div');
    group.className = 'bulk-search-printing';

    var head = document.createElement('div');
    head.className = 'bulk-search-printing__head';
    head.appendChild(imageEl(printing.image_url, 'bulk-search-printing__image'));
    var label = document.createElement('span');
    label.className = 'bulk-search-printing__label';
    label.textContent = printingLabel(printing) || t('unknown_printing');
    head.appendChild(label);
    group.appendChild(head);

    var variants = document.createElement('div');
    variants.className = 'bulk-search-printing__variants';
    (printing.variants || []).forEach(function (v) {
      if (v.available_qty <= 0) return;
      var dq = defaultQtyById[v.shopify_variant_id] || 0;
      variants.appendChild(buildVariant(v, dq));
    });
    group.appendChild(variants);

    return group;
  }

  /* ── A whole card: collapsible head + builder body ── */
  function buildCard(result) {
    var card = document.createElement('article');
    card.className = 'bulk-search-card';
    card.dataset.bulkSearchRow = '';
    card.dataset.status = result.status;
    card.dataset.requestedQty = result.requested_qty || 1;

    /* Default selection: cascade the requested qty across in-stock variants in the
       merchant's chosen price order (allVariants is pre-sorted by _priceSortDir).
       Fill each variant up to its available stock, then spill the remainder into
       the next, until the requested qty is met or stock runs out. The leftover (if
       any) surfaces as the "short" fill warning in recomputeCard. */
    var flat = allVariants(result);
    var defaultQtyById = {};
    var _remaining = result.requested_qty || 1;
    for (var _i = 0; _i < flat.length && _remaining > 0; _i++) {
      var _take = Math.min(_remaining, flat[_i].available_qty);
      if (_take > 0) {
        defaultQtyById[flat[_i].shopify_variant_id] = _take;
        _remaining -= _take;
      }
    }

    /* ── Head ── (a button when actionable, so the whole card toggles) */
    var head = document.createElement(result.status === 'found' ? 'button' : 'div');
    head.className = 'bulk-search-card__head';
    if (result.status === 'found') {
      head.type = 'button';
      head.dataset.bsToggle = '';
      head.setAttribute('aria-expanded', 'false');
    }

    var cardImage = (result.card && result.card.image_url)
      || (result.printings && result.printings[0] && result.printings[0].image_url)
      || null;
    head.appendChild(imageEl(cardImage, 'bulk-search-card__image'));

    var info = document.createElement('div');
    info.className = 'bulk-search-card__info';

    var name = document.createElement('span');
    name.className = 'bulk-search-card__name';
    if (result.card) {
      name.textContent = result.card.name;
    } else {
      name.textContent = result.raw;
      name.className += ' bulk-search-card__name--raw';
    }
    info.appendChild(name);

    var summary = document.createElement('span');
    summary.className = 'bulk-search-card__summary';
    summary.dataset.bsSummary = '';
    info.appendChild(summary);

    if (result.status === 'no_stock') {
      var ns = document.createElement('span');
      ns.className = 'bulk-search-card__status bulk-search-card__status--no-stock';
      ns.textContent = t('no_stock_message');
      info.appendChild(ns);
    } else if (result.status === 'not_found') {
      var nf = document.createElement('span');
      nf.className = 'bulk-search-card__status bulk-search-card__status--not-found';
      nf.textContent = t('not_found_message');
      info.appendChild(nf);
    }
    head.appendChild(info);

    if (result.status === 'found') {
      var meta = document.createElement('span');
      meta.className = 'bulk-search-card__meta';

      var fill = document.createElement('span');
      fill.className = 'bulk-search-card__fill';
      fill.dataset.bsFill = '';
      meta.appendChild(fill);

      var subtotal = document.createElement('span');
      subtotal.className = 'bulk-search-card__subtotal';
      subtotal.dataset.bsSubtotal = '';
      meta.appendChild(subtotal);

      var chevron = document.createElement('span');
      chevron.className = 'bulk-search-card__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '▾';
      meta.appendChild(chevron);

      head.appendChild(meta);
    }

    card.appendChild(head);

    /* ── Builder body ── */
    if (result.status === 'found') {
      var builderId = 'bs-builder-' + (++_cardSeq);
      var builder = document.createElement('div');
      builder.className = 'bulk-search-card__builder';
      builder.dataset.bsBuilder = '';
      builder.id = builderId;
      builder.hidden = true;
      head.setAttribute('aria-controls', builderId);

      (result.printings || []).forEach(function (pr) {
        var hasStock = (pr.variants || []).some(function (v) { return v.available_qty > 0; });
        if (hasStock) builder.appendChild(buildPrinting(pr, defaultQtyById));
      });
      card.appendChild(builder);

      head.addEventListener('click', function () {
        var open = builder.hidden;
        builder.hidden = !open;
        head.setAttribute('aria-expanded', String(open));
        card.classList.toggle('bulk-search-card--open', open);
      });

      recomputeCard(card);
    }

    return card;
  }

  /* Recompute a card's queued count, subtotal, fill counter + collapsed summary
     from its current variant steppers. */
  function recomputeCard(card) {
    var requested = parseInt(card.dataset.requestedQty, 10) || 1;
    var variants = card.querySelectorAll('[data-bs-variant]');
    var queued = 0, subtotal = 0, chosen = [];
    variants.forEach(function (v) {
      var input = v.querySelector('[data-bs-variant-qty]');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      if (qty <= 0) return;
      var price = parseInt(v.dataset.price, 10) || 0;
      queued += qty;
      subtotal += price * qty;
      var lbl = v.querySelector('.bulk-search-variant__label');
      chosen.push({ label: lbl ? lbl.textContent : '', qty: qty });
    });

    var fillEl = card.querySelector('[data-bs-fill]');
    if (fillEl) {
      fillEl.textContent = t('fill_counter', { queued: queued, requested: requested });
      fillEl.classList.toggle('bulk-search-card__fill--short', queued < requested);
      fillEl.classList.toggle('bulk-search-card__fill--over', queued > requested);
    }
    var subEl = card.querySelector('[data-bs-subtotal]');
    if (subEl) subEl.textContent = subtotal > 0 ? formatMoney(subtotal) : '';

    var sumEl = card.querySelector('[data-bs-summary]');
    if (sumEl) {
      if (!chosen.length) {
        sumEl.textContent = t('none_selected');
      } else if (chosen.length === 1) {
        sumEl.textContent = chosen[0].label + ' ×' + chosen[0].qty;
      } else {
        sumEl.textContent = t('mixed_selection', { count: chosen.length });
      }
    }
  }

  /* ================================================================
     MAIN CONTROLLER
  ================================================================ */

  function BulkSearch(container) {
    this.container      = container;
    this.resolveUrl     = container.dataset.resolveUrl || '/apps/sideboard/v1/bulk-resolve';
    this.useDemoData    = container.dataset.useDemo === 'true'
                         || new URLSearchParams(window.location.search).has('bulk_fixture');

    /* Merchant default price sort → module-global used by the sort comparators. */
    _priceSortDir = (container.dataset.priceSort === 'high_to_low') ? 'high_to_low' : 'low_to_high';

    /* Wire i18n from the Liquid-emitted JSON blob so every t() call resolves
       against real translated strings rather than JS fallbacks. */
    var i18nEl = container.querySelector('[data-bulk-search-i18n]');
    if (i18nEl) {
      try {
        var i18nData = JSON.parse(i18nEl.textContent);
        window.Sideboard = window.Sideboard || {};
        window.Sideboard.i18n = window.Sideboard.i18n || {};
        window.Sideboard.i18n.bulk_search = i18nData;
      } catch (e) { /* malformed JSON — JS fallbacks still work */ }
    }

    this.layout         = container.querySelector('[data-bulk-search-layout]');
    this.inputPanel     = container.querySelector('[data-bulk-search-input-panel]');
    this.resultsPanel   = container.querySelector('[data-bulk-search-results-panel]');
    this.textarea       = container.querySelector('[data-bulk-search-textarea]');
    this.resolveBtn     = container.querySelector('[data-bulk-search-resolve]');
    this.clearBtn       = container.querySelector('[data-bulk-search-clear]');
    this.errorEl        = container.querySelector('[data-bulk-search-error]');
    this.summaryBuckets = container.querySelector('[data-bulk-search-summary-buckets]');
    this.summaryTotal   = container.querySelector('[data-bulk-search-summary-total]');
    this.matchedEl      = container.querySelector('[data-bulk-search-matched]');
    this.liveEl         = container.querySelector('[data-bulk-search-live]');
    this.addAllBtn      = container.querySelector('[data-bulk-search-add-all]');
    this.backBtn        = container.querySelector('[data-bulk-search-back]');

    this._bind();

    if (this.useDemoData) {
      this._showDemoNotice();
    }
  }

  BulkSearch.prototype._bind = function () {
    var self = this;

    this.resolveBtn.addEventListener('click', function () {
      self._resolve();
    });

    this.clearBtn.addEventListener('click', function () {
      self._clear();
    });

    this.backBtn.addEventListener('click', function () {
      self._showInputPanel();
    });

    this.addAllBtn.addEventListener('click', function () {
      self._addAll();
    });

    /* Allow Enter in textarea to stay as newline — Ctrl/Cmd+Enter triggers resolve */
    this.textarea.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        self._resolve();
      }
    });

    /* Any variant stepper change → recompute that card, then the running total. */
    this.container.addEventListener('bulksearch:rowchange', function (e) {
      var card = e.target.closest('.bulk-search-card');
      if (card) recomputeCard(card);
      self._recomputeTotal();
    });
  };

  BulkSearch.prototype._announce = function (msg) {
    if (this.liveEl) this.liveEl.textContent = msg;
  };

  /* Running total across every selected variant stepper (sold-out rows excluded). */
  BulkSearch.prototype._recomputeTotal = function () {
    var total = 0;
    this.container.querySelectorAll('[data-bs-variant]').forEach(function (v) {
      if (v.classList.contains('bulk-search-variant--sold-out')) return;
      var input = v.querySelector('[data-bs-variant-qty]');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      var price = parseInt(v.dataset.price, 10) || 0;
      total += price * qty;
    });
    if (this.summaryTotal) {
      this.summaryTotal.textContent = total > 0 ? t('total_label') + ' ' + formatMoney(total) : '';
    }
  };

  BulkSearch.prototype._showDemoNotice = function () {
    var notice = document.createElement('div');
    notice.className = 'bulk-search__demo-notice';
    notice.setAttribute('role', 'status');
    notice.textContent = t('demo_notice');
    this.inputPanel.insertBefore(notice, this.inputPanel.firstChild);
  };

  BulkSearch.prototype._setResolveLoading = function (isLoading) {
    var text    = this.resolveBtn.querySelector('.bulk-search__resolve-text');
    var spinner = this.resolveBtn.querySelector('.bulk-search__resolve-spinner');
    this.resolveBtn.setAttribute('aria-busy', String(isLoading));
    this.resolveBtn.disabled = isLoading;
    if (text)    text.hidden    = isLoading;
    if (spinner) spinner.hidden = !isLoading;
  };

  BulkSearch.prototype._showError = function (msg) {
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  };

  BulkSearch.prototype._hideError = function () {
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  };

  BulkSearch.prototype._clear = function () {
    this.textarea.value = '';
    this._hideError();
    this._showInputPanel();
  };

  /* Input is always visible (split view). "Back" just collapses the results
     column so the layout returns to a single, full-width input. */
  BulkSearch.prototype._showInputPanel = function () {
    this.inputPanel.removeAttribute('hidden');
    this.resultsPanel.hidden = true;
    if (this.layout) this.layout.classList.remove('bulk-search__layout--has-results');
  };

  /* Reveal results beside the input — no takeover. */
  BulkSearch.prototype._showResultsPanel = function () {
    this.inputPanel.removeAttribute('hidden');
    this.resultsPanel.removeAttribute('hidden');
    if (this.layout) this.layout.classList.add('bulk-search__layout--has-results');
  };

  /* ──────────────────────────────────────────────────────────────────────
     Resolve = two stages with one shared hydrate:
       1. MATCH: Sideboard fuzzy-matches raw lines -> { raw, qty, status, handles }
          where status is matched | unmapped | not_found (unmapped = a real card
          this store hasn't pushed to Shopify; folded into not_found below).
          (Fallback when Sideboard is down: per line, strip qty, search Shopify
           by name, take the top product's handle.)
       2. HYDRATE: read LIVE variants/stock/price from Shopify (/products/<h>.js)
          and build the row shape buildRow renders. Shopify is the inventory truth.
     ────────────────────────────────────────────────────────────────────── */

  /* Leading integer = quantity; the entire rest of the line is the query. */
  function stripQty(raw) {
    var m = String(raw).trim().match(/^(\d+)\s*x?\s+(.+)$/i);
    return m ? { qty: parseInt(m[1], 10) || 1, query: m[2].trim() }
             : { qty: 1, query: String(raw).trim() };
  }

  var CONDITION_RANK = {
    near_mint: 0, lightly_played: 1, moderately_played: 2, heavily_played: 3, damaged: 4
  };

  /* Variant sort honouring the merchant's _priceSortDir setting. Price drives the
     order (asc for low_to_high, desc for high_to_low); on a price tie, better
     condition (NM first) always wins so the tiebreak stays intuitive either way. */
  function comparePrice(a, b) {
    var dir = (_priceSortDir === 'high_to_low') ? -1 : 1;
    return dir * (a.price - b.price)
        || ((CONDITION_RANK[a.condition] == null ? 9 : CONDITION_RANK[a.condition])
          - (CONDITION_RANK[b.condition] == null ? 9 : CONDITION_RANK[b.condition]));
  }

  function notFoundRow(raw, qty) {
    return { raw: raw, requested_qty: qty, status: 'not_found', card: null, printings: [] };
  }

  function fetchProductJs(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Shopify variant -> the variant shape the builder expects.
     NOTE (verify on staging): assumes option1 = condition, option2 = finish, and
     that storefront product.js exposes inventory_quantity; falls back to the
     `available` boolean for stock when it doesn't. */
  function variantOption(v) {
    return {
      shopify_variant_id: v.id,
      condition: String(v.option1 || '').toLowerCase().replace(/\s+/g, '_'),
      finish: String(v.option2 || 'normal').toLowerCase(),
      price: v.price,
      available_qty: (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : (v.available ? 99 : 0)
    };
  }

  /* { raw, qty, status, handles, printings } -> renderable card. Live stock / price /
     conditions come from Shopify (/products/<handle>.js); the backend's `printings`
     metadata (set label, collector #, image) is used only to label/group each handle
     — and is optional, so the builder still works (with product titles) before the
     backend ships it. Backend status is matched | unmapped | not_found; 'unmapped'
     (a real card this store hasn't pushed to Shopify) folds into the shopper-facing
     not_found bucket — there's no handle to buy either way. */
  function hydrateRow(row) {
    if (row.status === 'not_found' || row.status === 'unmapped' || !row.handles || !row.handles.length) {
      return Promise.resolve(notFoundRow(row.raw, row.qty));
    }

    var metaByHandle = {};
    (row.printings || []).forEach(function (p) { if (p && p.handle) metaByHandle[p.handle] = p; });

    return Promise.all(row.handles.map(function (h) {
      return fetchProductJs(h).then(function (p) { return { handle: h, product: p }; });
    })).then(function (fetched) {
      var printings = [];
      fetched.forEach(function (f) {
        if (!f.product) return;
        var inStock = (f.product.variants || [])
          .map(variantOption)
          .filter(function (o) { return o.available_qty > 0; });
        if (!inStock.length) return;
        inStock.sort(comparePrice);
        var meta = metaByHandle[f.handle] || {};
        printings.push({
          handle: f.handle,
          set_name: meta.set_name || null,
          set_code: meta.set_code || null,
          collector_number: meta.collector_number || null,
          image_url: meta.image_url || f.product.featured_image || (f.product.images && f.product.images[0]) || null,
          title: meta.name || f.product.title,
          variants: inStock
        });
      });

      /* Card identity: prefer the backend's name/image, else the first product. */
      var firstMeta = (row.printings && row.printings[0]) || {};
      var firstProduct = {};
      for (var i = 0; i < fetched.length; i++) {
        if (fetched[i].product) { firstProduct = fetched[i].product; break; }
      }
      var card = {
        name: firstMeta.name || firstProduct.title || row.raw,
        image_url: firstMeta.image_url || (printings[0] && printings[0].image_url) || null
      };

      if (!printings.length) {
        return { raw: row.raw, requested_qty: row.qty, status: 'no_stock', card: card, printings: [] };
      }
      return { raw: row.raw, requested_qty: row.qty, status: 'found', card: card, printings: printings };
    });
  }

  function summarize(results) {
    var s = { found: 0, no_stock: 0, not_found: 0 };
    results.forEach(function (r) { s[r.status] = (s[r.status] || 0) + 1; });
    return s;
  }

  BulkSearch.prototype._resolve = function () {
    var self    = this;
    var rawText = this.textarea.value.trim();
    this._hideError();

    if (!rawText) {
      this._showError('Please paste a card list before resolving.');
      return;
    }

    var lines = rawText.split('\n')
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l.length; });

    if (!lines.length) {
      this._showError('No card lines found.');
      return;
    }

    this._setResolveLoading(true);

    if (this.useDemoData) {
      setTimeout(function () {
        self._setResolveLoading(false);
        self._renderResults(BULK_SEARCH_FIXTURE);
      }, 600);
      return;
    }

    /* Primary: Sideboard fuzzy-match -> handles. On any failure, Shopify fallback. */
    fetch(this.resolveUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ lines: lines })
    })
    .then(function (resp) {
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      return resp.json();
    })
    .then(function (data) { return self._hydrate(data.results || []); })
    .catch(function () { return self._fallback(lines); })
    .then(function (results) {
      self._setResolveLoading(false);
      self._renderResults({ results: results, summary: summarize(results) });
    })
    .catch(function (err) {
      self._setResolveLoading(false);
      self._showError('Could not resolve list: ' + (err.message || 'Unknown error'));
    });
  };

  /* Hydrate Sideboard's matched rows from live Shopify product data. */
  BulkSearch.prototype._hydrate = function (rows) {
    return Promise.all(rows.map(hydrateRow));
  };

  /* Fallback (Sideboard unreachable): find the handle ourselves via Shopify search,
     then hydrate identically. Rougher matching, same render + add-to-cart. */
  BulkSearch.prototype._fallback = function (lines) {
    return Promise.all(lines.map(function (raw) {
      var parts = stripQty(raw);
      var url = '/search/suggest.json?q=' + encodeURIComponent(parts.query) +
                '&resources[type]=product&resources[limit]=1';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var handle = products.length ? products[0].handle : null;
          return hydrateRow({ raw: raw, qty: parts.qty, status: handle ? 'matched' : 'not_found', handles: handle ? [handle] : [] });
        })
        .catch(function () { return notFoundRow(raw, parts.qty); });
    }));
  };

  BulkSearch.prototype._renderResults = function (data) {
    var self    = this;
    var results = data.results || [];
    var summary = data.summary || {};

    /* Capture currency from response so formatMoney fallback path honours it */
    if (data.currency) _resolvedCurrency = data.currency;

    /* Summary pills — show all three buckets; skip only when count is 0 */
    this.summaryBuckets.replaceChildren();
    ['found', 'no_stock', 'not_found'].forEach(function (bucket) {
      var count = summary[bucket];
      if (!count) return;
      var pill = document.createElement('span');
      pill.className = 'bulk-search__summary-pill bulk-search__summary-pill--' + bucket;
      pill.textContent = t('buckets.' + bucket) + ': ' + count;
      self.summaryBuckets.appendChild(pill);
    });

    /* Matched headline: "{found} of {total} cards found" */
    var found = summary.found || 0;
    var totalLines = (summary.found || 0) + (summary.no_stock || 0) + (summary.not_found || 0);
    if (this.matchedEl) {
      this.matchedEl.textContent = totalLines
        ? t('summary_found', { count: found, total: totalLines })
        : '';
    }

    /* Populate buckets */
    var BUCKET_ORDER = ['found', 'no_stock', 'not_found'];
    BUCKET_ORDER.forEach(function (bucket) {
      var bucketEl  = self.container.querySelector('[data-bulk-search-bucket="' + bucket + '"]');
      var rowsEl    = bucketEl.querySelector('[data-bulk-search-bucket-rows]');
      var countEl   = bucketEl.querySelector('[data-bulk-search-bucket-count]');
      var bucketResults = results.filter(function (r) { return r.status === bucket; });

      rowsEl.replaceChildren();

      if (!bucketResults.length) {
        bucketEl.hidden = true;
        return;
      }

      bucketEl.hidden = false;
      if (countEl) countEl.textContent = '(' + bucketResults.length + ')';

      bucketResults.forEach(function (result) {
        rowsEl.appendChild(buildCard(result));
      });
    });

    /* Enable add-all when any card has a buildable selection */
    this.addAllBtn.disabled = !results.some(function (r) { return r.status === 'found'; });

    /* Live running total from the freshly-built steppers, then announce. */
    this._recomputeTotal();
    this._announce(t('results_announce', { count: found, total: totalLines }));

    this._showResultsPanel();
  };

  BulkSearch.prototype._addAll = function () {
    var self = this;

    /* Collect {id, quantity} from every selected variant stepper. A single card can
       contribute several line items — different printings/conditions the buyer mixed. */
    var items = [];
    this.container.querySelectorAll('[data-bs-variant]').forEach(function (v) {
      if (v.classList.contains('bulk-search-variant--sold-out')) return;
      var variantId = parseInt(v.dataset.variantId, 10);
      if (!variantId) return;
      var input = v.querySelector('[data-bs-variant-qty]');
      var qty = input ? (parseInt(input.value, 10) || 0) : 0;
      if (qty <= 0) return;
      items.push({ id: variantId, quantity: qty });
    });

    if (!items.length) return;

    /* Chunk if needed: Shopify /cart/add.js handles up to ~250 line items
       but large payloads are unusual. Split at 100 to stay safe. */
    var CHUNK_SIZE = 100;
    var chunks     = [];
    for (var i = 0; i < items.length; i += CHUNK_SIZE) {
      chunks.push(items.slice(i, i + CHUNK_SIZE));
    }

    var addAllText    = this.addAllBtn.querySelector('.bulk-search__add-all-text');
    var addAllSpinner = this.addAllBtn.querySelector('.bulk-search__add-all-spinner');
    this.addAllBtn.setAttribute('aria-busy', 'true');
    this.addAllBtn.disabled = true;
    if (addAllText)    addAllText.hidden    = true;
    if (addAllSpinner) addAllSpinner.hidden = false;

    var failedItems = [];

    /* Process chunks sequentially.
       Shopify /cart/add.js is atomic: if ANY variant in the payload is OOS it 422s and
       adds NOTHING. Strategy:
         - 422 → retry one item at a time so in-stock survivors still add; mark OOS rows.
         - non-422 (network/5xx) → real error; surface it to the user and stop. */
    function processChunk(chunkIndex) {
      if (chunkIndex >= chunks.length) {
        finish();
        return;
      }

      var chunk = chunks[chunkIndex];

      /* Use Sideboard cart API if available (handles drawer refresh) */
      if (window.Sideboard && window.Sideboard.cart) {
        window.Sideboard.cart.add(chunk)
        .then(function () {
          processChunk(chunkIndex + 1);
        })
        .catch(function (err) {
          if (err && err.status === 422) {
            /* Stock lag: one bad variant killed the whole batch — retry one-by-one so
               in-stock survivors still add and only the OOS item gets flagged. */
            retryOneByOne(chunk, 0, function () {
              processChunk(chunkIndex + 1);
            });
          } else {
            /* Real error (network, 5xx, etc.) — surface it, do not silently swallow */
            self._showError(t('partial_add_notice') + (err && err.message ? ' (' + err.message + ')' : ''));
            finishWithError();
          }
        });
      } else {
        /* Fallback: direct fetch */
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: chunk }),
        })
        .then(function (resp) {
          if (resp.status === 422) {
            /* Retry one-by-one (same reasoning as Sideboard path above) */
            return resp.json().then(function () {
              retryOneByOne(chunk, 0, function () {
                processChunk(chunkIndex + 1);
              });
            });
          }
          if (!resp.ok) {
            throw Object.assign(new Error('HTTP ' + resp.status), { status: resp.status });
          }
          return resp.json().then(function () {
            processChunk(chunkIndex + 1);
          });
        })
        .catch(function (err) {
          /* Real network/5xx error */
          self._showError(t('partial_add_notice') + (err && err.message ? ' (' + err.message + ')' : ''));
          finishWithError();
        });
      }
    }

    /* Per-item retry: called only after a chunk-level 422.
       For each single item: 422 → mark sold-out and continue; non-422 → surface error. */
    function retryOneByOne(chunk, index, done) {
      if (index >= chunk.length) { done(); return; }
      var item = chunk[index];

      var addFn;
      if (window.Sideboard && window.Sideboard.cart) {
        addFn = window.Sideboard.cart.add([item]);
      } else {
        addFn = fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        }).then(function (resp) {
          if (!resp.ok) throw Object.assign(new Error('HTTP ' + resp.status), { status: resp.status });
          return resp.json();
        });
      }

      addFn
        .then(function () { retryOneByOne(chunk, index + 1, done); })
        .catch(function (err) {
          if (err && err.status === 422) {
            /* This specific variant is OOS — mark it and continue */
            failedItems.push(item.id);
            retryOneByOne(chunk, index + 1, done);
          } else {
            /* Real error on a single item — surface it, stop retrying */
            self._showError(t('partial_add_notice') + (err && err.message ? ' (' + err.message + ')' : ''));
            finishWithError();
          }
        });
    }

    function finish() {
      /* Stock lag: zero out + badge each sold-out variant, then recompute. */
      if (failedItems.length) {
        failedItems.forEach(function (variantId) {
          var vrow = self.container.querySelector('[data-bs-variant][data-variant-id="' + variantId + '"]');
          if (!vrow) return;
          vrow.classList.add('bulk-search-variant--sold-out');
          var input = vrow.querySelector('[data-bs-variant-qty]');
          if (input) { input.value = '0'; input.disabled = true; }
          if (!vrow.querySelector('.bulk-search-variant__sold-out')) {
            var badge = document.createElement('span');
            badge.className = 'bulk-search-variant__sold-out';
            badge.textContent = t('sold_out_label');
            vrow.appendChild(badge);
          }
          var card = vrow.closest('.bulk-search-card');
          if (card) recomputeCard(card);
        });
        self._recomputeTotal();

        var notice = document.createElement('div');
        notice.className = 'bulk-search__partial-notice';
        notice.setAttribute('role', 'status');
        notice.textContent = t('partial_add_notice');
        self.container.querySelector('[data-bulk-search-add-bar]').before(notice);
      }

      self._announce(failedItems.length
        ? t('added_announce_partial', { added: items.length - failedItems.length, failed: failedItems.length })
        : t('added_announce', { added: items.length }));

      /* Reset button */
      self.addAllBtn.setAttribute('aria-busy', 'false');
      self.addAllBtn.disabled = false;
      if (addAllText)    addAllText.hidden    = false;
      if (addAllSpinner) addAllSpinner.hidden = true;

      /* Open cart drawer if Sideboard cart API is present */
      if (window.Sideboard && window.Sideboard.cart && window.Sideboard.cart.open) {
        window.Sideboard.cart.open();
      }
    }

    /* Called on real (non-422) errors — resets button state without opening the drawer */
    function finishWithError() {
      self.addAllBtn.setAttribute('aria-busy', 'false');
      self.addAllBtn.disabled = false;
      if (addAllText)    addAllText.hidden    = false;
      if (addAllSpinner) addAllSpinner.hidden = true;
    }

    processChunk(0);
  };

  /* ── Init ── */
  document.querySelectorAll('[data-bulk-search]').forEach(function (el) {
    new BulkSearch(el);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function() {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
  var countEl = drawer.querySelector('[data-cart-drawer-count]');
  var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  var footer = drawer.querySelector('[data-cart-drawer-footer]');
  var content = drawer.querySelector('[data-cart-drawer-content]');

  /**
   * Load cart recommendations for the first cart item via the Product
   * Recommendations API + Section Rendering. Re-queries the container each call so
   * it survives the drawer re-rendering, and skips refetching when the lead product
   * is unchanged.
   */
  var lastRecProductId = null;
  function loadRecommendations(state) {
    var recsEl = drawer.querySelector('[data-cart-recommendations]');
    if (!recsEl) return;
    var items = (state && state.items) || [];
    var productId = items.length ? items[0].product_id : null;
    if (!productId) { recsEl.innerHTML = ''; lastRecProductId = null; return; }
    if (productId === lastRecProductId && recsEl.innerHTML.trim()) return;
    lastRecProductId = productId;
    var intent = recsEl.getAttribute('data-intent') || 'related';
    var limit = recsEl.getAttribute('data-limit') || '4';
    fetch('/recommendations/products?section_id=cart-recommendations&product_id=' +
      encodeURIComponent(productId) + '&intent=' + encodeURIComponent(intent) +
      '&limit=' + encodeURIComponent(limit), { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.text() : ''; })
      .then(function(html) {
        var el = drawer.querySelector('[data-cart-recommendations]');
        if (el) el.innerHTML = html;
      })
      .catch(function() {});
  }

  /**
   * Wait for Cart API to be ready
   */
  function waitForCartApi() {
    return new Promise(function(resolve) {
      if (window.Sideboard && window.Sideboard.cart) {
        resolve(window.Sideboard.cart);
      } else {
        var checkInterval = setInterval(function() {
          if (window.Sideboard && window.Sideboard.cart) {
            clearInterval(checkInterval);
            resolve(window.Sideboard.cart);
          }
        }, 50);
      }
    });
  }

  waitForCartApi().then(function(cart) {
    // Subscribe to cart changes
    cart.subscribe(function(state, action, detail) {
      updateDrawerContent(state, action, detail);
    });

    // Add to cart from a recommendation (delegated on the drawer so it survives re-render)
    drawer.addEventListener('click', function(e) {
      var recBtn = e.target.closest('[data-recommend-add]');
      if (!recBtn) return;
      e.preventDefault();
      var vid = parseInt(recBtn.getAttribute('data-variant-id'), 10);
      if (vid) cart.add([ { id: vid, quantity: 1 } ]);
    });

    // Initial recommendations load
    if (cart.state) loadRecommendations(cart.state);

    // Handle quantity changes via event delegation
    drawer.addEventListener('click', function(e) {
      var decreaseBtn = e.target.closest('[data-drawer-qty-decrease]');
      var increaseBtn = e.target.closest('[data-drawer-qty-increase]');
      var removeBtn = e.target.closest('[data-drawer-remove]');

      var item = e.target.closest('[data-cart-drawer-item]');
      if (!item) return;

      var key = item.dataset.key;
      var input = item.querySelector('[data-drawer-qty-input]');

      if (decreaseBtn && input) {
        e.preventDefault();
        var current = parseInt(input.value) || 1;
        var newQty = Math.max(0, current - 1);
        input.value = newQty || 1;

        if (newQty === 0) {
          item.classList.add('is-removing');
        } else {
          item.classList.add('is-updating');
        }

        cart.update(key, newQty).finally(function() {
          item.classList.remove('is-updating');
        });
      }

      if (increaseBtn && input) {
        e.preventDefault();
        var currentVal = parseInt(input.value) || 1;
        var maxQty = input.max ? parseInt(input.max) : Infinity;
        if (currentVal >= maxQty) return;
        var newQtyVal = Math.min(currentVal + 1, maxQty);
        input.value = newQtyVal;
        // Immediate feedback; the server re-render makes it authoritative
        if (newQtyVal >= maxQty) increaseBtn.disabled = true;

        item.classList.add('is-updating');
        cart.update(key, newQtyVal).finally(function() {
          item.classList.remove('is-updating');
        });
      }

      if (removeBtn) {
        e.preventDefault();
        item.classList.add('is-removing');
        cart.remove(key);
      }
    });

    // Handle quantity input changes
    drawer.addEventListener('change', function(e) {
      var input = e.target.closest('[data-drawer-qty-input]');
      if (!input) return;

      var item = input.closest('[data-cart-drawer-item]');
      if (!item) return;

      var key = item.dataset.key;
      var max = input.max ? parseInt(input.max) : Infinity;
      var qty = Math.max(1, Math.min(parseInt(input.value) || 1, max));
      input.value = qty;

      item.classList.add('is-updating');
      cart.update(key, qty).finally(function() {
        item.classList.remove('is-updating');
      });
    });
  });

  /**
   * Update drawer content based on cart state
   */
  function updateDrawerContent(state, action, detail) {
    if (!state) return;

    // Refresh recommendations for the cart's lead product
    loadRecommendations(state);

    // Update count
    if (countEl) {
      countEl.textContent = '(' + state.item_count + ')';
    }

    // Update subtotal
    if (subtotalEl && window.Sideboard && window.Sideboard.cart) {
      subtotalEl.textContent = window.Sideboard.cart.formatMoney(state.total_price);
    }

    // Update free-shipping progress bar
    var fsBar = drawer.querySelector('[data-shipping-bar]');
    if (fsBar && window.Sideboard && window.Sideboard.cart) {
      var fsThreshold = parseInt(fsBar.getAttribute('data-threshold'), 10) || 0;
      if (fsThreshold > 0) {
        var fsRemaining = fsThreshold - state.total_price;
        var fsPct = Math.min(100, Math.round((state.total_price / fsThreshold) * 100));
        var fsFill = fsBar.querySelector('[data-shipping-bar-fill]');
        var fsText = fsBar.querySelector('[data-shipping-bar-text]');
        if (fsFill) fsFill.style.width = fsPct + '%';
        if (fsText) {
          if (fsRemaining > 0) {
            var fsTmpl = fsBar.getAttribute('data-msg-remaining') || 'Add __AMT__ for free shipping';
            fsText.textContent = fsTmpl.replace('__AMT__', window.Sideboard.cart.formatMoney(fsRemaining));
          } else {
            fsText.textContent = fsBar.getAttribute('data-msg-qualified') || '';
          }
        }
      }
    }

    // Toggle empty state vs items
    if (state.item_count === 0) {
      showEmptyState();
    } else {
      hideEmptyState();

      // If section HTML was provided via bundled rendering, update from it
      // Note: Section HTML from Shopify's API is server-rendered (trusted content)
      if (detail && detail.sectionHtml) {
        updateItemsFromServer(detail.sectionHtml);
      }
    }
  }

  /**
   * Show empty state
   */
  function showEmptyState() {
    if (itemsContainer) itemsContainer.style.display = 'none';
    if (footer) footer.style.display = 'none';

    // Create empty state if it doesn't exist
    if (!emptyState && content) {
      var emptyDiv = document.createElement('div');
      emptyDiv.className = 'cart-drawer__empty';
      emptyDiv.setAttribute('data-cart-drawer-empty', '');

      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('class', 'cart-drawer__empty-icon');
      icon.setAttribute('width', '48');
      icon.setAttribute('height', '48');
      icon.setAttribute('viewBox', '0 0 48 48');
      icon.setAttribute('fill', 'none');
      icon.setAttribute('aria-hidden', 'true');

      var path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path1.setAttribute('d', 'M14 14h28l-4 20H18L14 14z');
      path1.setAttribute('stroke', 'currentColor');
      path1.setAttribute('stroke-width', '2');
      path1.setAttribute('stroke-linejoin', 'round');

      var path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path2.setAttribute('d', 'M14 14l-2-8H6');
      path2.setAttribute('stroke', 'currentColor');
      path2.setAttribute('stroke-width', '2');
      path2.setAttribute('stroke-linecap', 'round');
      path2.setAttribute('stroke-linejoin', 'round');

      var circle1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle1.setAttribute('cx', '20');
      circle1.setAttribute('cy', '42');
      circle1.setAttribute('r', '2');
      circle1.setAttribute('fill', 'currentColor');

      var circle2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      circle2.setAttribute('cx', '36');
      circle2.setAttribute('cy', '42');
      circle2.setAttribute('r', '2');
      circle2.setAttribute('fill', 'currentColor');

      icon.appendChild(path1);
      icon.appendChild(path2);
      icon.appendChild(circle1);
      icon.appendChild(circle2);

      var text = document.createElement('p');
      text.className = 'cart-drawer__empty-text';
      text.textContent = 'Your cart is empty';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cart-drawer__continue-btn';
      btn.setAttribute('data-cart-drawer-close', '');
      btn.textContent = 'Continue shopping';

      emptyDiv.appendChild(icon);
      emptyDiv.appendChild(text);
      emptyDiv.appendChild(btn);
      content.appendChild(emptyDiv);

      emptyState = emptyDiv;
    } else if (emptyState) {
      emptyState.style.display = '';
    }
  }

  /**
   * Hide empty state
   */
  function hideEmptyState() {
    if (itemsContainer) itemsContainer.style.display = '';
    if (footer) footer.style.display = '';
    if (emptyState) emptyState.style.display = 'none';
  }

  /**
   * Update items list from server-rendered section HTML
   * Note: This HTML comes from Shopify's Section Rendering API (trusted source)
   */
  function updateItemsFromServer(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');

    // Update items list - replace only the item content, preserving container
    var newItems = doc.querySelector('[data-cart-drawer-items]');
    if (newItems && itemsContainer) {
      // Get current item keys for comparison
      var currentKeys = [];
      itemsContainer.querySelectorAll('[data-cart-drawer-item]').forEach(function(item) {
        currentKeys.push(item.dataset.key);
      });

      // Replace content with server-rendered HTML (trusted from Shopify)
      while (itemsContainer.firstChild) {
        itemsContainer.removeChild(itemsContainer.firstChild);
      }

      // Move children from parsed doc to live DOM
      while (newItems.firstChild) {
        itemsContainer.appendChild(newItems.firstChild);
      }

      // Highlight newly added items
      itemsContainer.querySelectorAll('[data-cart-drawer-item]').forEach(function(item) {
        if (currentKeys.indexOf(item.dataset.key) === -1) {
          item.classList.add('is-new');
          setTimeout(function() {
            item.classList.remove('is-new');
          }, 600);
        }
      });
    }

    // Update subtotal from server HTML
    var newSubtotal = doc.querySelector('[data-cart-drawer-subtotal]');
    if (newSubtotal && subtotalEl) {
      subtotalEl.textContent = newSubtotal.textContent;
    }

    // Update count from server HTML
    var newCount = doc.querySelector('[data-cart-drawer-count]');
    if (newCount && countEl) {
      countEl.textContent = newCount.textContent;
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  const cartSection = document.querySelector('.cart-section');
  if (!cartSection) return;

  const sectionId = cartSection.closest('.shopify-section')?.id || 'cart-section';

  let clickHandler = null;
  let changeHandler = null;
  let cartChangeHandler = null;

  function init() {
    const cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    // Use Cart API if available for unified state management
    async function updateCart(input) {
      const cartItem = input.closest('[data-cart-item]');
      const key = cartItem.dataset.key;
      const quantity = parseInt(input.value, 10);

      cartItem.style.opacity = '0.5';

      // Use Cart API if available
      if (window.Sideboard && window.Sideboard.cart) {
        try {
          if (quantity === 0) {
            await window.Sideboard.cart.remove(key);
            cartItem.remove();
            // Check if cart is empty - Cart API state will have updated
            const cartState = window.Sideboard.cart.state;
            if (cartState && cartState.item_count === 0) {
              window.location.reload();
            }
          } else {
            await window.Sideboard.cart.update(key, quantity);
            cartItem.style.opacity = '1';
          }
          // Totals update handled by cart change listener
        } catch (err) {
          if (err.message !== 'Debounced') {
            console.error('Cart update failed', err);
            cartItem.style.opacity = '1';
          }
        }
      } else {
        // Fallback to direct fetch
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
          });
          const cart = await response.json();

          if (quantity === 0) {
            cartItem.remove();
            if (cart.item_count === 0) {
              window.location.reload();
            }
          } else {
            cartItem.style.opacity = '1';
          }
          updateTotals(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } catch (err) {
          console.error('Cart update failed', err);
          cartItem.style.opacity = '1';
        }
      }
    }

    function updateTotals(cart) {
      const subtotal = document.querySelector('[data-cart-subtotal]');
      const total = document.querySelector('[data-cart-total]');
      const count = document.querySelector('.cart__count');

      const price = cart.total_price;
      const formattedPrice = formatMoney(price);

      if (subtotal) subtotal.textContent = formattedPrice;
      if (total) total.textContent = formattedPrice;
      if (count) count.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');

      const titleCount = document.querySelector('[data-cart-count-title]');
      if (titleCount) titleCount.textContent = cart.item_count;

      updateLinePrices(cart);
    }

    // Disable + at the inventory cap (the input's max, set from
    // inventory_quantity when the variant denies overselling)
    function syncStepperLimits() {
      document.querySelectorAll('[data-quantity-input]').forEach(function(input) {
        const plus = input.parentElement.querySelector('[data-quantity-plus]');
        if (!plus) return;
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        plus.disabled = parseInt(input.value, 10) >= max;
      });
    }

    // Line prices were static markup before — only the totals refreshed after
    // a quantity change, so each row's price went stale until a reload.
    function updateLinePrices(cart) {
      if (!cart.items) return;
      document.querySelectorAll('[data-cart-item]').forEach(function(el) {
        const item = cart.items.find(function(i) { return i.key === el.dataset.key; });
        if (!item) return;

        el.querySelectorAll('[data-line-price]').forEach(function(p) {
          p.textContent = formatMoney(item.final_line_price);
        });

        el.querySelectorAll('[data-line-price-compare]').forEach(function(c) {
          const discounted = item.original_line_price !== item.final_line_price;
          if (discounted) c.textContent = formatMoney(item.original_line_price);
          c.hidden = !discounted;
        });

        el.querySelectorAll('[data-unit-price]').forEach(function(u) {
          u.textContent = formatMoney(item.final_price);
        });

        el.querySelectorAll('[data-unit-wrap]').forEach(function(w) {
          w.hidden = item.quantity < 2;
        });

        // Snap the input to what the cart actually accepted (Shopify caps
        // silently at available stock), then re-sync the + button state
        el.querySelectorAll('[data-quantity-input]').forEach(function(input) {
          if (parseInt(input.value, 10) !== item.quantity) input.value = item.quantity;
        });
      });

      syncStepperLimits();
    }

    function formatMoney(cents) {
      if (window.Sideboard && window.Sideboard.cart && window.Sideboard.cart.formatMoney) {
        return window.Sideboard.cart.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    // Listen for Cart API changes to update totals
    cartChangeHandler = function(e) {
      const cart = e.detail && e.detail.cart ? e.detail.cart : e.detail;
      if (cart) {
        updateTotals(cart);
      }
    };
    document.addEventListener('sideboard:cart:change', cartChangeHandler);

    clickHandler = function(e) {
      const minusBtn = e.target.closest('[data-quantity-minus]');
      const plusBtn = e.target.closest('[data-quantity-plus]');
      const removeBtn = e.target.closest('[data-remove-item]');

      if (minusBtn) {
        const input = minusBtn.parentElement.querySelector('[data-quantity-input]');
        const newVal = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = newVal;
        updateCart(input);
      }

      if (plusBtn) {
        const input = plusBtn.parentElement.querySelector('[data-quantity-input]');
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        const current = parseInt(input.value, 10);
        if (current >= max) return;
        input.value = Math.min(max, current + 1);
        syncStepperLimits();
        updateCart(input);
      }

      if (removeBtn) {
        const cartItem = removeBtn.closest('[data-cart-item]');
        const input = cartItem.querySelector('[data-quantity-input]');
        input.value = 0;
        updateCart(input);
      }
    };

    changeHandler = function(e) {
      if (e.target.matches('[data-quantity-input]')) {
        const input = e.target;
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        if (parseInt(input.value, 10) > max) input.value = max;
        syncStepperLimits();
        updateCart(input);
      }
    };

    cartForm.addEventListener('click', clickHandler);
    cartForm.addEventListener('change', changeHandler);
    syncStepperLimits();
  }

  function cleanup() {
    const cartForm = document.querySelector('[data-cart-form]');
    if (cartForm) {
      if (clickHandler) {
        cartForm.removeEventListener('click', clickHandler);
        clickHandler = null;
      }
      if (changeHandler) {
        cartForm.removeEventListener('change', changeHandler);
        changeHandler = null;
      }
    }
    if (cartChangeHandler) {
      document.removeEventListener('sideboard:cart:change', cartChangeHandler);
      cartChangeHandler = null;
    }
  }

  // Initialize on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const registry = new Map();

    function initCollectionSlider(slider) {
      const track = slider.querySelector('.collection-list__track');
      if (!track) return;

      const prevBtn = slider.querySelector('[data-slider-prev]');
      const nextBtn = slider.querySelector('[data-slider-next]');
      const isAutoplay = slider.hasAttribute('data-autoplay');

      const instance = { autoplayInterval: null, handlers: [] };

      const getScrollAmount = () => {
        const card = track.querySelector('.collection-card');
        if (!card) return 300;
        const gap = parseFloat(getComputedStyle(track).gap) || 24;
        return card.offsetWidth + gap;
      };

      const updateNavVisibility = () => {
        if (!prevBtn || !nextBtn) return;
        const isAtStart = track.scrollLeft <= 0;
        const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        prevBtn.style.visibility = isAtStart ? 'hidden' : 'visible';
        nextBtn.style.visibility = isAtEnd ? 'hidden' : 'visible';
      };

      if (prevBtn) {
        const handlePrev = () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        prevBtn.addEventListener('click', handlePrev);
        instance.handlers.push({ el: prevBtn, event: 'click', fn: handlePrev });
      }

      if (nextBtn) {
        const handleNext = () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        nextBtn.addEventListener('click', handleNext);
        instance.handlers.push({ el: nextBtn, event: 'click', fn: handleNext });
      }

      track.addEventListener('scroll', updateNavVisibility);
      instance.handlers.push({ el: track, event: 'scroll', fn: updateNavVisibility });
      updateNavVisibility();

      if (isAutoplay) {
        const speed = parseInt(getComputedStyle(slider).getPropertyValue('--autoplay-speed')) || 5000;

        const stopAutoplay = () => clearInterval(instance.autoplayInterval);
        const startAutoplay = () => {
          stopAutoplay();
          instance.autoplayInterval = setInterval(() => {
            const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
            if (isAtEnd) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            }
          }, speed);
        };

        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', startAutoplay);
        instance.handlers.push(
          { el: slider, event: 'mouseenter', fn: stopAutoplay },
          { el: slider, event: 'mouseleave', fn: startAutoplay },
          { el: slider, event: 'focusin', fn: stopAutoplay },
          { el: slider, event: 'focusout', fn: startAutoplay }
        );

        startAutoplay();
      }

      registry.set(slider, instance);
    }

    function destroyCollectionSlider(slider) {
      const instance = registry.get(slider);
      if (!instance) return;
      if (instance.autoplayInterval) clearInterval(instance.autoplayInterval);
      instance.handlers.forEach(({ el, event, fn }) => el.removeEventListener(event, fn));
      registry.delete(slider);
    }

    document.querySelectorAll('[data-collection-slider]').forEach(initCollectionSlider);

    // Theme editor support
    document.addEventListener('shopify:section:load', (event) => {
      const slider = event.target.querySelector('[data-collection-slider]');
      if (slider) initCollectionSlider(slider);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const slider = event.target.querySelector('[data-collection-slider]');
      if (slider) destroyCollectionSlider(slider);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Mobile filter drawer toggle with focus trap and ESC key support
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filtersDrawer = document.querySelector('[data-collection-filters]');
  var filtersOverlay = document.querySelector('[data-filters-overlay]');
  var closeBtn = document.querySelector('[data-filters-close]');

  // Applied-filter count on the button. Filters live in the URL and change via
  // pushState, so recount on every collection:updated. A price band (gte + lte) is one filter.
  var filterCountEl = document.querySelector('[data-filter-count]');
  var updateFilterCount = function() {
    if (!filterCountEl) return;
    var count = 0;
    var priceCounted = false;
    new URLSearchParams(window.location.search).forEach(function(value, key) {
      if (key.indexOf('filter.') !== 0 || value === '') return;
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        if (priceCounted) return;
        priceCounted = true;
      }
      count++;
    });
    filterCountEl.textContent = count > 0 ? ' (' + count + ')' : '';
  };
  updateFilterCount();
  document.addEventListener('collection:updated', updateFilterCount);

  // Focus trap state
  var previouslyFocusedElement = null;
  var focusTrapHandler = null;
  var escapeHandler = null;

  if (filterToggle && filtersDrawer && filtersOverlay) {
    // Get focusable elements within the drawer
    var getFocusableElements = function() {
      return filtersDrawer.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), details summary'
      );
    };

    // Trap focus within the drawer
    var trapFocus = function(e) {
      var focusable = getFocusableElements();
      if (focusable.length === 0) return;

      var firstFocusable = focusable[0];
      var lastFocusable = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    };

    function openFilters() {
      previouslyFocusedElement = document.activeElement;
      filtersDrawer.classList.add('is-open');
      filtersOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      filterToggle.setAttribute('aria-expanded', 'true');

      // Set up focus trap
      focusTrapHandler = function(e) {
        if (e.key === 'Tab') {
          trapFocus(e);
        }
      };
      document.addEventListener('keydown', focusTrapHandler);

      // Set up ESC key handler
      escapeHandler = function(e) {
        if (e.key === 'Escape') {
          closeFilters();
        }
      };
      document.addEventListener('keydown', escapeHandler);

      // Focus the close button after opening
      setTimeout(function() {
        if (closeBtn) {
          closeBtn.focus();
        } else {
          var focusable = getFocusableElements();
          if (focusable.length > 0) {
            focusable[0].focus();
          }
        }
      }, 50);
    }

    function closeFilters() {
      filtersDrawer.classList.remove('is-open');
      filtersOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
      filterToggle.setAttribute('aria-expanded', 'false');

      // Remove focus trap
      if (focusTrapHandler) {
        document.removeEventListener('keydown', focusTrapHandler);
        focusTrapHandler = null;
      }

      // Remove ESC handler
      if (escapeHandler) {
        document.removeEventListener('keydown', escapeHandler);
        escapeHandler = null;
      }

      // Return focus to toggle button
      if (previouslyFocusedElement && previouslyFocusedElement.focus) {
        previouslyFocusedElement.focus();
      }
    }

    filterToggle.addEventListener('click', openFilters);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeFilters);
    }

    filtersOverlay.addEventListener('click', closeFilters);
  }

  // View mode toggle (grid/list)
  var STORAGE_KEY = 'sideboard-collection-view';
  var viewToggleBtns = document.querySelectorAll('[data-view-toggle]');

  if (viewToggleBtns.length > 0) {
    // Query the grid live on each use: AJAX filtering/pagination replaces the
    // content container, so a reference captured at load goes stale (detached
    // node). The toggle buttons live outside the container, so they persist.
    function getGrid() {
      return document.querySelector('[data-collection-grid]');
    }

    // Get saved preference or use the grid's default
    function getSavedView() {
      try {
        var saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'grid' || saved === 'list') {
          return saved;
        }
      } catch (e) {
        // localStorage not available
      }
      var grid = getGrid();
      return (grid && grid.dataset.defaultView) || 'grid';
    }

    // Save preference
    function saveView(view) {
      try {
        localStorage.setItem(STORAGE_KEY, view);
      } catch (e) {
        // localStorage not available
      }
    }

    // Update view mode
    function setViewMode(view) {
      var grid = getGrid();
      if (grid) grid.dataset.viewMode = view;

      // Update aria-pressed states
      viewToggleBtns.forEach(function(btn) {
        var btnView = btn.dataset.viewToggle;
        btn.setAttribute('aria-pressed', btnView === view ? 'true' : 'false');
      });

      saveView(view);
    }

    // Initialize from saved preference
    setViewMode(getSavedView());

    // Handle toggle clicks
    viewToggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setViewMode(btn.dataset.viewToggle);
      });
    });

    // Re-apply the saved view to the freshly-swapped grid after AJAX
    // filtering/pagination replaces the content container.
    var collectionContent = document.querySelector('[data-collection-content]');
    if (collectionContent) {
      collectionContent.addEventListener('collection:updated', function() {
        setViewMode(getSavedView());
      });
    }
  }

  // AJAX pagination - intercept pagination link clicks
  var contentContainer = document.querySelector('[data-collection-content]');
  if (contentContainer) {
    contentContainer.addEventListener('click', function(e) {
      // Check if clicked on a pagination link
      var paginationLink = e.target.closest('.collection__pagination a');
      if (!paginationLink) return;

      var href = paginationLink.getAttribute('href');
      if (!href) return;

      // Use AJAX update if available
      if (typeof window.ajaxFilterUpdate === 'function') {
        e.preventDefault();
        window.ajaxFilterUpdate(href);
      }
    });
  }

  // In Stock filter (toolbar) — shown when the sidebar has no Sideboard In-Stock
  // toggle. Same URL semantics as the sidebar toggle: checked = in-stock only (=1),
  // unchecked = show all (=0,1, kept explicit). Uses AJAX filtering when available
  // (S&D mode renders the filter form + ajaxFilterUpdate), else a full navigation.
  var instockToggle = document.querySelector('[data-collection-instock]');
  if (instockToggle) {
    // Reflect the URL honestly (read in JS — Liquid can't read query params):
    // checked only when filter.v.availability=1 is actually present.
    instockToggle.checked = new URLSearchParams(window.location.search).get('filter.v.availability') === '1';
    function applyInstock(checked) {
      var url = new URL(window.location.href);
      url.searchParams.set('filter.v.availability', checked ? '1' : '0,1');
      if (typeof window.ajaxFilterUpdate === 'function') {
        window.ajaxFilterUpdate(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }
    instockToggle.addEventListener('change', function() {
      applyInstock(this.checked);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"] && !Shopify.designMode) return;
  try {
    
(function() {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;

  const STORAGE_KEY = 'cookie_consent';
  const consentMode = banner.dataset.consentMode;
  const isModal = banner.dataset.position === 'modal';
  const expiryDays = parseInt(banner.dataset.expiryDays, 10) || 365;

  // Default consent state (denied)
  const defaultConsent = {
    essential: true,
    analytics: false,
    marketing: false,
    functional: false,
    timestamp: null
  };

  // Get stored consent
  const getStoredConsent = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (e) {}
    return null;
  };

  // Save consent
  const saveConsent = (consent) => {
    consent.timestamp = Date.now();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    updateGoogleConsent(consent);
  };

  // Update Google Consent Mode v2
  const updateGoogleConsent = (consent) => {
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        'ad_storage': consent.marketing ? 'granted' : 'denied',
        'ad_user_data': consent.marketing ? 'granted' : 'denied',
        'ad_personalization': consent.marketing ? 'granted' : 'denied',
        'analytics_storage': consent.analytics ? 'granted' : 'denied',
        'functionality_storage': consent.functional ? 'granted' : 'denied',
        'personalization_storage': consent.functional ? 'granted' : 'denied',
        'security_storage': 'granted'
      });
    }

    // Dispatch custom event for other scripts
    window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: consent }));
  };

  // Check if consent has expired
  const isConsentExpired = (consent) => {
    if (!consent || !consent.timestamp) return true;
    const daysSince = (Date.now() - consent.timestamp) / (1000 * 60 * 60 * 24);
    return daysSince >= expiryDays;
  };

  // Focus trap variables
  let previouslyFocusedElement = null;
  let focusTrapHandler = null;
  let escapeHandler = null;

  const getFocusableElements = () => {
    const container = banner.querySelector('.cookie-consent__container');
    return container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  };

  const trapFocus = (e) => {
    const focusable = getFocusableElements();
    if (focusable.length === 0) return;

    const firstFocusable = focusable[0];
    const lastFocusable = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  };

  // Show banner
  const showBanner = () => {
    previouslyFocusedElement = document.activeElement;
    banner.hidden = false;
    requestAnimationFrame(() => banner.classList.add('is-visible'));

    // Only the modal style is a blocking dialog: trap focus, handle ESC, and
    // pull focus into it. The corner/bar banners stay non-modal so they never
    // steal keyboard focus from the page.
    if (isModal) {
      focusTrapHandler = (e) => {
        if (e.key === 'Tab') {
          trapFocus(e);
        }
      };
      document.addEventListener('keydown', focusTrapHandler);

      escapeHandler = (e) => {
        if (e.key === 'Escape' && !banner.hidden) {
          dismiss();
        }
      };
      document.addEventListener('keydown', escapeHandler);

      setTimeout(() => {
        const focusable = getFocusableElements();
        if (focusable.length > 0) {
          focusable[0].focus();
        }
      }, 50);
    }
  };

  // Hide banner
  const hideBanner = () => {
    banner.hidden = true;
    banner.classList.remove('is-visible');

    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
      focusTrapHandler = null;
    }
    if (escapeHandler) {
      document.removeEventListener('keydown', escapeHandler);
      escapeHandler = null;
    }

    // Return focus to the trigger only when we'd moved it (modal).
    if (isModal && previouslyFocusedElement && previouslyFocusedElement.focus) {
      previouslyFocusedElement.focus();
    }
  };

  // Dismissing without choosing (modal close / overlay / ESC): on first run,
  // record a "decline" so a decision is stored and the banner stops re-nagging;
  // when reopened to manage existing prefs, just close.
  const dismiss = () => {
    if (getStoredConsent()) {
      hideBanner();
    } else {
      declineAll();
    }
  };

  // Accept all
  const acceptAll = () => {
    const consent = {
      essential: true,
      analytics: true,
      marketing: true,
      functional: true
    };
    saveConsent(consent);
    hideBanner();
  };

  // Decline all (except essential)
  const declineAll = () => {
    const consent = { ...defaultConsent };
    saveConsent(consent);
    hideBanner();
  };

  // Save current preferences (granular mode)
  const savePreferences = () => {
    const consent = { essential: true };
    const toggles = banner.querySelectorAll('[data-cc-toggle]');
    toggles.forEach(toggle => {
      consent[toggle.dataset.ccToggle] = toggle.checked;
    });
    saveConsent(consent);
    hideBanner();
  };

  // Initialize toggles with stored values
  const initToggles = (consent) => {
    const toggles = banner.querySelectorAll('[data-cc-toggle]');
    toggles.forEach(toggle => {
      const category = toggle.dataset.ccToggle;
      if (consent && consent[category] !== undefined) {
        toggle.checked = consent[category];
      }
    });
  };

  // Event listeners
  banner.querySelectorAll('[data-cc-accept]').forEach(btn => {
    btn.addEventListener('click', acceptAll);
  });

  banner.querySelectorAll('[data-cc-decline]').forEach(btn => {
    btn.addEventListener('click', declineAll);
  });

  banner.querySelectorAll('[data-cc-save]').forEach(btn => {
    btn.addEventListener('click', savePreferences);
  });

  banner.querySelectorAll('[data-cc-close]').forEach(btn => {
    btn.addEventListener('click', dismiss);
  });

  // Customize (granular): reveal the toggles + Save, hide the Customize button.
  const optionsEl = banner.querySelector('[data-cc-options]');
  const saveBtn = banner.querySelector('[data-cc-save]');
  const customizeBtn = banner.querySelector('[data-cc-customize]');
  const expandOptions = () => {
    if (optionsEl) optionsEl.hidden = false;
    if (saveBtn) saveBtn.hidden = false;
    if (customizeBtn) {
      customizeBtn.hidden = true;
      customizeBtn.setAttribute('aria-expanded', 'true');
    }
  };
  if (customizeBtn) {
    customizeBtn.addEventListener('click', expandOptions);
  }

  // "Manage preferences" link support
  document.querySelectorAll('[data-open-cookie-preferences]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const consent = getStoredConsent();
      if (consent) {
        initToggles(consent);
      }
      // Reopened to manage prefs → show the toggles straight away.
      if (consentMode === 'granular') {
        expandOptions();
      }
      showBanner();
    });
  });

  // Initialize
  const storedConsent = getStoredConsent();

  if (!storedConsent || isConsentExpired(storedConsent)) {
    // Set default denied state for Google Consent Mode
    if (typeof gtag === 'function') {
      gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'granted',
        'wait_for_update': 500
      });
    }
    showBanner();
  } else {
    // Apply stored consent
    updateGoogleConsent(storedConsent);
    initToggles(storedConsent);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('[data-countdown-section]');
  if (!section) return;

  const sectionId = section.closest('.shopify-section')?.id || section.id;
  let intervalId = null;

  function init() {
    const targetDateStr = section.dataset.targetDate;
    const hideAfterExpiry = section.hasAttribute('data-hide-after-expiry');
    const timer = section.querySelector('[data-countdown-timer]');
    const expiredEl = section.querySelector('[data-countdown-expired]');

    if (!targetDateStr || !timer) return;

    const targetDate = new Date(targetDateStr).getTime();

    const daysEl = section.querySelector('[data-days]');
    const hoursEl = section.querySelector('[data-hours]');
    const minutesEl = section.querySelector('[data-minutes]');
    const secondsEl = section.querySelector('[data-seconds]');

    const padNumber = (num) => String(num).padStart(2, '0');

    const updateCountdown = () => {
      const now = Date.now();
      const distance = targetDate - now;

      if (distance <= 0) {
        cleanup();
        timer.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (hideAfterExpiry) section.hidden = true;
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const isBlocks = section.classList.contains('countdown--blocks');

      if (daysEl) daysEl.textContent = isBlocks ? padNumber(days) : days;
      if (hoursEl) hoursEl.textContent = isBlocks ? padNumber(hours) : hours;
      if (minutesEl) minutesEl.textContent = isBlocks ? padNumber(minutes) : minutes;
      if (secondsEl) secondsEl.textContent = isBlocks ? padNumber(seconds) : seconds;
    };

    updateCountdown();
    intervalId = setInterval(updateCountdown, 1000);
  }

  function cleanup() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  init();

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-details"]) return;
  try {
    
(function () {
  const section = document.querySelector('[data-event-details-section]');
  if (!section) return;

  const sectionId = section.closest('.shopify-section')?.id || section.id;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  // Matches the fallback used elsewhere in the theme (snippets/product-card.liquid,
  // snippets/cart-api.liquid) so a page where window.Shopify hasn't loaded yet can't
  // throw here.
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function init() {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const form = section.querySelector('[data-event-form]');
    if (!form) return;

    const qtyInput = form.querySelector('[data-qty-input]');
    const decreaseBtn = form.querySelector('[data-qty-decrease]');
    const increaseBtn = form.querySelector('[data-qty-increase]');
    const priceEl = form.querySelector('[data-selected-price]');
    const radios = form.querySelectorAll('[data-variant-radio]');

    function getSelectedPriceCents() {
      const checkedRadio = form.querySelector('[data-variant-radio]:checked');
      const source = checkedRadio || form.querySelector('[data-price-cents]');
      if (!source) return null;
      const cents = parseInt(source.dataset.priceCents, 10);
      return Number.isNaN(cents) ? null : cents;
    }

    function updatePrice() {
      if (!priceEl) return;
      const priceCents = getSelectedPriceCents();
      if (priceCents === null) return;
      const qty = parseInt(qtyInput?.value, 10) || 1;
      priceEl.textContent = formatMoney(priceCents * qty);
    }

    function syncToVariant(radio) {
      if (!radio) return;
      const max = parseInt(radio.dataset.maxQty, 10) || 1;
      if (qtyInput) {
        qtyInput.max = String(max);
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(clamp(current, 1, Math.max(max, 1)));
      }
      updatePrice();
    }

    if (decreaseBtn && qtyInput) {
      decreaseBtn.addEventListener('click', function () {
        const min = parseInt(qtyInput.min, 10) || 1;
        const max = parseInt(qtyInput.max, 10) || min;
        const current = parseInt(qtyInput.value, 10) || min;
        qtyInput.value = String(clamp(current - 1, min, max));
        updatePrice();
      });
    }

    if (increaseBtn && qtyInput) {
      increaseBtn.addEventListener('click', function () {
        const min = parseInt(qtyInput.min, 10) || 1;
        const max = parseInt(qtyInput.max, 10) || min;
        const current = parseInt(qtyInput.value, 10) || min;
        qtyInput.value = String(clamp(current + 1, min, max));
        updatePrice();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', updatePrice);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) syncToVariant(radio);
      });
    });

    updatePrice();
  }

  function cleanup() {
    section.dataset.initialized = 'false';
  }

  init();

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.detail.sectionId === sectionId) cleanup();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-overview"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupSection(root) {
    var viewBtns = root.querySelectorAll('[data-view-btn]');
    var panels = root.querySelectorAll('[data-view-panel]');

    function setView(view) {
      viewBtns.forEach(function (btn) {
        var active = btn.dataset.view === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.viewPanel !== view;
      });
    }

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.dataset.view);
      });
    });

    var initialView = root.dataset.defaultView === 'list' ? 'list' : 'calendar';
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      initialView = 'list';
    }
    setView(initialView);

    // ---- month nav + Today ----
    var monthTables = root.querySelectorAll('[data-month-table]');
    var prevBtn = root.querySelector('[data-calendar-prev]');
    var nextBtn = root.querySelector('[data-calendar-next]');
    var todayBtn = root.querySelector('[data-calendar-today]');

    function currentMonthIndex() {
      for (var i = 0; i < monthTables.length; i++) {
        if (!monthTables[i].hidden) return i;
      }
      return 0;
    }

    function showMonth(index) {
      monthTables.forEach(function (table, i) {
        table.hidden = i !== index;
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= monthTables.length - 1;
      // Table index 0 is always the current month (see the Today handler
      // below) — disable Today whenever it's already showing, so the control
      // itself signals "you're on the current month" (SID-815) and a click
      // on it can never be a no-op.
      if (todayBtn) todayBtn.disabled = index === 0;
    }

    if (monthTables.length) {
      showMonth(currentMonthIndex());
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var idx = currentMonthIndex();
        if (idx > 0) showMonth(idx - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var idx = currentMonthIndex();
        if (idx < monthTables.length - 1) showMonth(idx + 1);
      });
    }

    if (todayBtn) {
      todayBtn.addEventListener('click', function () {
        // Today means today's month, full stop. Table index 0 is always the
        // current month (the Liquid table walk starts at current_month_key),
        // and the aria-current cell exists whether or not today has events —
        // never month-hop to the next upcoming event (SID-811: on a store
        // whose events all start next month, that made this button land on
        // that month from anywhere, and look dead once you were on it).
        showMonth(0);
        var target = monthTables[0] && monthTables[0].querySelector('td[aria-current="date"]');
        if (target) {
          // A game filter can hide the first anchor in this cell (or every
          // anchor in it) — grab the first one that's actually visible, not
          // just the first in DOM order (NEW-4); fall back to the cell
          // itself when nothing in it is currently visible.
          var candidates = target.querySelectorAll('a');
          var link = null;
          for (var j = 0; j < candidates.length; j++) {
            if (!candidates[j].closest('[hidden]')) {
              link = candidates[j];
              break;
            }
          }
          var focusTarget = link || target;
          if (!link && !focusTarget.hasAttribute('tabindex')) {
            focusTarget.setAttribute('tabindex', '-1');
          }
          focusTarget.focus({ preventScroll: false });
          focusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // ---- game filter chips ----
    var chipBtns = root.querySelectorAll('[data-game-chip]');
    var emptyFiltered = root.querySelector('[data-empty-filtered]');
    var clearBtn = root.querySelector('[data-clear-filters]');

    // The pipeline's own game match is case-insensitive; chip values (from
    // distinct, stripped-but-not-cased `game` values) and event-card's own
    // `data-game` (raw, unstripped) can disagree in case/whitespace even when
    // they mean the same game, so every comparison normalizes both operands.
    function normalizeGame(value) {
      return (value || '').trim().toLowerCase();
    }

    // Snapshot each calendar day-cell slot's default (Liquid-rendered)
    // visibility ONCE, before any filter ever runs, so clearing a filter can
    // restore the original `calendar_events_per_day` cap exactly rather than
    // guessing at it client-side.
    var daySlots = root.querySelectorAll('[data-day-rank]');
    daySlots.forEach(function (slot) {
      slot.dataset.defaultHidden = slot.hidden ? 'true' : 'false';
    });

    // ---- list cap (SID-820): same rank-slot precedent as the calendar's
    // `[data-day-rank]`, but counting events rather than resetting per day.
    // `listExpanded` tracks the merchant's own "Show all" click, which is a
    // different act than filtering — once a shopper has asked to see
    // everything, clearing a game filter shouldn't re-cap the list on them.
    var listSlots = root.querySelectorAll('[data-list-rank]');
    listSlots.forEach(function (slot) {
      slot.dataset.defaultHidden = slot.hidden ? 'true' : 'false';
    });
    var showAllBtn = root.querySelector('[data-list-show-all]');
    var listExpanded = false;

    if (showAllBtn) {
      showAllBtn.addEventListener('click', function () {
        listExpanded = true;
        listSlots.forEach(function (slot) {
          slot.hidden = false;
        });
        showAllBtn.hidden = true;
        updateDayGroups();
      });
    }

    // A list row/calendar cell only reads as visible if BOTH its own
    // `[data-game]` hidden state (filter match) and its rank slot's hidden
    // state (day/list cap) agree — either alone hiding it is enough to hide
    // it from a day group's count, so a group can go stranded from either
    // mechanism, not just from filtering (F3).
    function isEffectivelyVisible(el) {
      if (el.hidden) return false;
      var slot = el.closest('[data-list-rank]');
      return !(slot && slot.hidden);
    }

    function updateDayGroups() {
      root.querySelectorAll('[data-day-group]').forEach(function (group) {
        var events = group.querySelectorAll('[data-game]');
        var visible = Array.prototype.filter.call(events, isEffectivelyVisible).length;
        group.hidden = events.length > 0 && visible === 0;
      });
    }

    function applyFilter(game) {
      var normGame = normalizeGame(game);

      chipBtns.forEach(function (btn) {
        var active = normalizeGame(btn.dataset.game) === normGame;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // Every filterable element EXCEPT the chip controls themselves — chips
      // also carry `data-game` (for their own active-state styling), and an
      // unscoped `[data-game]` query used to hide "All games" right along
      // with everything else, making the filter impossible to undo (F1).
      var items = root.querySelectorAll('[data-game]:not([data-game-chip])');
      items.forEach(function (el) {
        var matches = !normGame || normalizeGame(el.dataset.game) === normGame;
        el.hidden = !matches;
      });

      // Calendar day cells: reveal EVERY matching row regardless of its
      // default rank/cap while a filter is active — a capped-out row can be
      // the only match for a filtered game, and the cell must agree with
      // what the list shows (F5). Clearing the filter restores each slot's
      // snapshotted default visibility instead of re-deriving the cap.
      root.querySelectorAll('[data-day-cell]').forEach(function (cell) {
        var slots = cell.querySelectorAll('[data-day-rank]');
        var visibleCount = 0;
        slots.forEach(function (slot) {
          var card = slot.querySelector('[data-game]');
          var matches = !normGame || (card && normalizeGame(card.dataset.game) === normGame);
          if (normGame) {
            slot.hidden = !matches;
          } else {
            slot.hidden = slot.dataset.defaultHidden === 'true';
          }
          if (matches && !slot.hidden) visibleCount++;
        });
        var td = cell.closest('.events-calendar__day');
        if (td) td.classList.toggle('is-filtered-empty', slots.length > 0 && visibleCount === 0);
        var more = cell.querySelector('[data-more-link]');
        if (more) more.hidden = Boolean(normGame);
      });

      // List cap: same reveal-regardless-of-rank-while-filtered, restore-on-
      // clear behavior as the calendar's day-rank slots above (F5) — except
      // "restore" means "back to the merchant's cap", and if the shopper
      // already clicked "Show all" this session, clearing a filter leaves
      // everything showing rather than re-imposing the cap on them.
      listSlots.forEach(function (slot) {
        var card = slot.querySelector('[data-game]');
        var matches = !normGame || (card && normalizeGame(card.dataset.game) === normGame);
        if (normGame) {
          slot.hidden = !matches;
        } else {
          slot.hidden = listExpanded ? false : slot.dataset.defaultHidden === 'true';
        }
      });
      if (showAllBtn) {
        showAllBtn.hidden = Boolean(normGame) || listExpanded;
      }

      updateDayGroups();

      var anyVisible = Array.prototype.some.call(items, function (el) {
        return !el.hidden;
      });
      var showFilteredEmpty = Boolean(normGame) && !anyVisible;
      if (emptyFiltered) emptyFiltered.hidden = !showFilteredEmpty;
      root.classList.toggle('is-filtered-empty', showFilteredEmpty);
    }

    chipBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.game || '');
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        applyFilter('');
      });
    }

    // ---- day anchor: switch to List, scroll, highlight ----
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#day-"]');
      if (!link || !root.contains(link)) return;
      var id = link.getAttribute('href').slice(1);
      var group = document.getElementById(id);
      if (!group) return;
      event.preventDefault();
      setView('list');
      // A day this far out can be entirely past the list cap (SID-820) even
      // though the calendar itself has no total-count cap — reveal just this
      // day's rows so a direct link to a specific day always lands somewhere
      // visible, rather than scrolling to a `hidden` group.
      if (group.hidden) {
        group.hidden = false;
        group.querySelectorAll('[data-list-rank]').forEach(function (slot) {
          slot.hidden = false;
        });
      }
      group.classList.add('is-highlighted');
      window.setTimeout(function () {
        group.classList.remove('is-highlighted');
      }, 2000);
      group.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var heading = group.querySelector('.events-overview__day-heading');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-events-overview]').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      setupSection(root);
    });
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-events-overview]');
    if (root) root.dataset.initialized = 'false';
    initAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('[data-faq-section]');

  sections.forEach(section => {
    const toggleAllBtn = section.querySelector('[data-expand-all]');
    const details = section.querySelectorAll('details');

    if (!toggleAllBtn || details.length === 0) return;

    let allExpanded = false;

    const updateButtonText = () => {
      const expandText = toggleAllBtn.dataset.expandText || 'Expand all';
      const collapseText = toggleAllBtn.dataset.collapseText || 'Collapse all';
      toggleAllBtn.textContent = allExpanded ? collapseText : expandText;
    };

    toggleAllBtn.addEventListener('click', () => {
      allExpanded = !allExpanded;
      details.forEach(detail => {
        detail.open = allExpanded;
      });
      updateButtonText();
    });

    // Track state when individual items are toggled
    details.forEach(detail => {
      detail.addEventListener('toggle', () => {
        const allOpen = Array.from(details).every(d => d.open);
        const allClosed = Array.from(details).every(d => !d.open);
        if (allOpen) allExpanded = true;
        else if (allClosed) allExpanded = false;
        updateButtonText();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const instanceRegistry = new Map();

    function initFcCarousel(section) {
      const track = section.querySelector('[data-carousel-track]');
      const prevBtn = section.querySelector('[data-carousel-prev]');
      const nextBtn = section.querySelector('[data-carousel-next]');
      const isAutoplay = section.hasAttribute('data-autoplay');

      if (!track) return;

      const instance = {
        autoplayInterval: null,
        handlers: []
      };

      const getScrollAmount = () => {
        const item = track.querySelector('.featured-collection__item');
        if (!item) return 300;
        const gap = parseFloat(getComputedStyle(track).gap) || 24;
        return item.offsetWidth + gap;
      };

      const updateNavState = () => {
        if (!prevBtn || !nextBtn) return;
        const isAtStart = track.scrollLeft <= 1;
        const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = isAtStart;
        nextBtn.disabled = isAtEnd;
      };

      if (prevBtn && nextBtn) {
        const handlePrev = () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        const handleNext = () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });

        prevBtn.addEventListener('click', handlePrev);
        nextBtn.addEventListener('click', handleNext);
        track.addEventListener('scroll', updateNavState);

        instance.handlers.push(
          { el: prevBtn, event: 'click', fn: handlePrev },
          { el: nextBtn, event: 'click', fn: handleNext },
          { el: track, event: 'scroll', fn: updateNavState }
        );

        updateNavState();
      }

      if (isAutoplay && prevBtn && nextBtn) {
        const speed = parseInt(getComputedStyle(section).getPropertyValue('--autoplay-speed')) || 5000;

        const startAutoplay = () => {
          instance.autoplayInterval = setInterval(() => {
            const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
            if (isAtEnd) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            }
          }, speed);
        };

        const stopAutoplay = () => {
          clearInterval(instance.autoplayInterval);
        };

        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
        section.addEventListener('focusin', stopAutoplay);
        section.addEventListener('focusout', startAutoplay);

        instance.handlers.push(
          { el: section, event: 'mouseenter', fn: stopAutoplay },
          { el: section, event: 'mouseleave', fn: startAutoplay },
          { el: section, event: 'focusin', fn: stopAutoplay },
          { el: section, event: 'focusout', fn: startAutoplay }
        );

        startAutoplay();
      }

      instanceRegistry.set(section.id, instance);
    }

    function destroyFcCarousel(sectionId) {
      const instance = instanceRegistry.get(sectionId);
      if (!instance) return;

      if (instance.autoplayInterval) {
        clearInterval(instance.autoplayInterval);
      }

      instance.handlers.forEach(({ el, event, fn }) => {
        el.removeEventListener(event, fn);
      });

      instanceRegistry.delete(sectionId);
    }

    // Initialize all carousels on page load
    document.querySelectorAll('[data-fc-carousel]').forEach(initFcCarousel);

    // Theme editor support
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-fc-carousel]');
      if (section) initFcCarousel(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-fc-carousel]');
      if (section) destroyFcCarousel(section.id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function() {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  const sectionId = header.closest('.shopify-section')?.id || header.id;

  // Event handler references for cleanup
  let scrollHandler = null;
  let toggleClickHandler = null;
  let overlayClickHandler = null;
  let closeBtnClickHandler = null;
  let accordionHandlers = [];
  let mobileSearchToggleClickHandler = null;
  let searchToggleClickHandler = null;
  let searchOverlayClickHandler = null;
  let escapeHandler = null;
  let resizeHandler = null;
  let cartChangeHandler = null;

  function init() {
    const stickyHeader = document.querySelector('[data-sticky-header]');
    const transparentHeader = document.querySelector('[data-transparent-header]');
    const showOnScrollUp = document.querySelector('[data-show-on-scroll-up]');
    const scrollThreshold = 50;
    const hideThreshold = 100;
    let lastScrollY = 0;
    let ticking = false;

    function handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;

      if (stickyHeader) {
        if (scrollY > 0) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
      }

      if (transparentHeader) {
        if (scrollY > scrollThreshold) {
          header.classList.add('header--solid');
        } else {
          header.classList.remove('header--solid');
        }
      }

      if (showOnScrollUp && stickyHeader) {
        if (scrollY > hideThreshold) {
          if (scrollY > lastScrollY) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }
        } else {
          header.classList.remove('header--hidden');
        }
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    scrollHandler = function() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    };

    if (stickyHeader || transparentHeader || showOnScrollUp) {
      window.addEventListener('scroll', scrollHandler, { passive: true });
      handleScroll();
    }

    // Mobile drawer
    const toggle = document.querySelector('.header__menu-toggle');
    const drawer = document.getElementById('mobile-nav-drawer');
    const overlay = drawer ? drawer.querySelector('.header__drawer-overlay') : null;
    const closeBtn = drawer ? drawer.querySelector('.header__drawer-close') : null;

    function openDrawer() {
      if (!toggle || !drawer) return;
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!toggle || !drawer) return;
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (toggle) {
      toggleClickHandler = function() {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeDrawer();
        } else {
          openDrawer();
        }
      };
      toggle.addEventListener('click', toggleClickHandler);
    }

    if (overlay) {
      overlayClickHandler = closeDrawer;
      overlay.addEventListener('click', overlayClickHandler);
    }

    if (closeBtn) {
      closeBtnClickHandler = closeDrawer;
      closeBtn.addEventListener('click', closeBtnClickHandler);
    }

    // Mobile search icon (mobile_search: icon) — a second way into the same
    // drawer, landing on its search field. Opens rather than toggles: tapping
    // search should never be the thing that closes search.
    const mobileSearchToggle = document.querySelector('.header__mobile-search-toggle');
    if (mobileSearchToggle) {
      mobileSearchToggleClickHandler = function() {
        const alreadyOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
        if (!alreadyOpen) openDrawer();
        // Absent when show_search is off — the button is gated on the same
        // setting, but the drawer markup is the one that owns the input.
        const drawerSearchInput = drawer ? drawer.querySelector('[data-predictive-search-input]') : null;
        if (!drawerSearchInput) return;
        // Matched to the drawer's 0.3s slide; focusing mid-transition drops
        // the mobile keyboard. Already-open needs no wait.
        setTimeout(function() {
          drawerSearchInput.focus();
        }, alreadyOpen ? 0 : 300);
      };
      mobileSearchToggle.addEventListener('click', mobileSearchToggleClickHandler);
    }

    // Drawer accordions
    const accordionTriggers = document.querySelectorAll('[data-drawer-accordion] .header__drawer-accordion-trigger');
    accordionTriggers.forEach(function(trigger) {
      const handler = function() {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const content = trigger.nextElementSibling;
        trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        content.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
      };
      trigger.addEventListener('click', handler);
      accordionHandlers.push({ el: trigger, handler });
    });

    // Search popover
    const searchToggle = document.querySelector('.header__search-toggle');
    const searchPopover = document.getElementById('header-search-popover');
    const searchOverlay = searchPopover ? searchPopover.querySelector('.header__search-popover-overlay') : null;
    const searchInput = searchPopover ? searchPopover.querySelector('[data-predictive-search-input]') : null;

    function openSearchPopover() {
      if (!searchToggle || !searchPopover) return;
      searchToggle.setAttribute('aria-expanded', 'true');
      searchPopover.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        if (searchInput) searchInput.focus();
      }, 250);
    }

    function closeSearchPopover() {
      if (!searchToggle || !searchPopover) return;
      searchToggle.setAttribute('aria-expanded', 'false');
      searchPopover.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (searchToggle) {
      searchToggleClickHandler = function() {
        const isExpanded = searchToggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeSearchPopover();
        } else {
          openSearchPopover();
        }
      };
      searchToggle.addEventListener('click', searchToggleClickHandler);
    }

    if (searchOverlay) {
      searchOverlayClickHandler = closeSearchPopover;
      searchOverlay.addEventListener('click', searchOverlayClickHandler);
    }

    // Close on escape key
    escapeHandler = function(e) {
      if (e.key === 'Escape') {
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          closeDrawer();
        }
        if (searchPopover && searchPopover.getAttribute('aria-hidden') === 'false') {
          closeSearchPopover();
        }
      }
    };
    document.addEventListener('keydown', escapeHandler);

    // Cart count listener - update every badge (bar + drawer) when cart changes
    const cartCountEls = document.querySelectorAll('[data-cart-count]');
    if (cartCountEls.length) {
      cartChangeHandler = function(e) {
        const cart = e.detail && e.detail.cart ? e.detail.cart : e.detail;
        if (!cart) return;

        const count = cart.item_count || 0;
        cartCountEls.forEach(function(cartCountEl) {
          cartCountEl.textContent = count;

          // Show/hide based on count
          if (count === 0) {
            cartCountEl.classList.add('header__cart-count--hidden');
          } else {
            cartCountEl.classList.remove('header__cart-count--hidden');
          }

          // Bounce animation on add
          if (e.detail && e.detail.action === 'add') {
            cartCountEl.classList.remove('header__cart-count--bounce');
            // Trigger reflow to restart animation
            void cartCountEl.offsetWidth;
            cartCountEl.classList.add('header__cart-count--bounce');
          }
        });
      };
      document.addEventListener('sideboard:cart:change', cartChangeHandler);
    }

    // Close drawer on resize to desktop
    resizeHandler = function() {
      if (window.innerWidth >= 990) {
        const isHamburgerDesktop = header && header.classList.contains('header--hamburger-desktop');
        if (!isHamburgerDesktop && drawer && drawer.getAttribute('aria-hidden') === 'false') {
          closeDrawer();
        }
      }
    };
    window.addEventListener('resize', resizeHandler);
  }

  function cleanup() {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }

    const toggle = document.querySelector('.header__menu-toggle');
    if (toggle && toggleClickHandler) {
      toggle.removeEventListener('click', toggleClickHandler);
      toggleClickHandler = null;
    }

    const drawer = document.getElementById('mobile-nav-drawer');
    const overlay = drawer ? drawer.querySelector('.header__drawer-overlay') : null;
    const closeBtn = drawer ? drawer.querySelector('.header__drawer-close') : null;

    if (overlay && overlayClickHandler) {
      overlay.removeEventListener('click', overlayClickHandler);
      overlayClickHandler = null;
    }

    if (closeBtn && closeBtnClickHandler) {
      closeBtn.removeEventListener('click', closeBtnClickHandler);
      closeBtnClickHandler = null;
    }

    const mobileSearchToggle = document.querySelector('.header__mobile-search-toggle');
    if (mobileSearchToggle && mobileSearchToggleClickHandler) {
      mobileSearchToggle.removeEventListener('click', mobileSearchToggleClickHandler);
      mobileSearchToggleClickHandler = null;
    }

    accordionHandlers.forEach(function({ el, handler }) {
      el.removeEventListener('click', handler);
    });
    accordionHandlers = [];

    const searchToggle = document.querySelector('.header__search-toggle');
    if (searchToggle && searchToggleClickHandler) {
      searchToggle.removeEventListener('click', searchToggleClickHandler);
      searchToggleClickHandler = null;
    }

    const searchPopover = document.getElementById('header-search-popover');
    const searchOverlay = searchPopover ? searchPopover.querySelector('.header__search-popover-overlay') : null;
    if (searchOverlay && searchOverlayClickHandler) {
      searchOverlay.removeEventListener('click', searchOverlayClickHandler);
      searchOverlayClickHandler = null;
    }

    if (escapeHandler) {
      document.removeEventListener('keydown', escapeHandler);
      escapeHandler = null;
    }

    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }

    if (cartChangeHandler) {
      document.removeEventListener('sideboard:cart:change', cartChangeHandler);
      cartChangeHandler = null;
    }

    // Reset body overflow
    document.body.style.overflow = '';
  }

  // Initialize on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.hero__slide');
      this.dots = container.querySelectorAll('[data-slide-dot]');
      this.prevBtn = container.querySelector('[data-slide-prev]');
      this.nextBtn = container.querySelector('[data-slide-next]');

      this.currentIndex = 0;
      this.slideCount = this.slides.length;
      this.autoplay = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000 || 5000;
      this.transition = container.dataset.transition || 'fade';
      this.autoplayTimer = null;
      this.isPaused = false;
      this.visibilityChangeHandler = null;

      if (this.slideCount <= 1) return;

      this.init();
    }

    init() {
      this.bindEvents();

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    bindEvents() {
      // Arrow navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.nextSlide());
      }

      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Pause on hover
      this.container.addEventListener('mouseenter', () => this.pause());
      this.container.addEventListener('mouseleave', () => this.resume());

      // Pause on focus within (for accessibility) - debounced to prevent rapid focus cycling
      let focusTimeout = null;
      this.container.addEventListener('focusin', () => {
        clearTimeout(focusTimeout);
        this.pause();
      });
      this.container.addEventListener('focusout', (e) => {
        if (!this.container.contains(e.relatedTarget)) {
          focusTimeout = setTimeout(() => this.resume(), 100);
        }
      });

      // Keyboard navigation
      this.container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.prevSlide();
        } else if (e.key === 'ArrowRight') {
          this.nextSlide();
        }
      });

      // Handle visibility change (pause when tab is hidden)
      this.visibilityChangeHandler = () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.resume();
        }
      };
      document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      const prevIndex = this.currentIndex;
      this.currentIndex = index;

      // Update slides
      this.slides.forEach((slide, i) => {
        slide.classList.remove('hero__slide--active', 'hero__slide--prev', 'hero__slide--next');

        if (i === this.currentIndex) {
          slide.classList.add('hero__slide--active');
        } else if (this.transition === 'slide') {
          // For slide transition, position non-active slides
          if (i < this.currentIndex) {
            slide.classList.add('hero__slide--prev');
          } else {
            slide.classList.add('hero__slide--next');
          }
        }
      });

      // Update dots
      this.dots.forEach((dot, i) => {
        const isActive = i === this.currentIndex;
        dot.classList.toggle('hero__nav-dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
          dot.setAttribute('aria-current', 'step');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      // Reset autoplay timer
      if (this.autoplay && !this.isPaused) {
        this.startAutoplay();
      }
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slideCount;
      this.goToSlide(nextIndex);
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        if (!this.isPaused) {
          this.nextSlide();
        }
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    pause() {
      this.isPaused = true;
      this.container.dataset.paused = 'true';
    }

    resume() {
      this.isPaused = false;
      this.container.dataset.paused = 'false';
    }

    destroy() {
      this.stopAutoplay();
      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }
    }
  }

  // Initialize all hero slideshows
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hero-slideshow]').forEach((container) => {
      new HeroSlideshow(container);
    });
  });

  // Re-initialize on Shopify section events (for theme editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const container = e.target.querySelector('[data-hero-slideshow]');
      if (container) {
        new HeroSlideshow(container);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  const galleries = document.querySelectorAll('[data-image-gallery][data-lightbox]');

  galleries.forEach(gallery => {
    const lightbox = gallery.querySelector('[data-lightbox]');
    const lightboxImage = gallery.querySelector('[data-lightbox-image]');
    const triggers = gallery.querySelectorAll('[data-lightbox-trigger]');
    const closeButtons = gallery.querySelectorAll('[data-lightbox-close]');

    if (!lightbox || !lightboxImage) return;

    const openLightbox = (imageUrl, imageAlt) => {
      lightboxImage.src = imageUrl;
      lightboxImage.alt = imageAlt || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      lightbox.hidden = true;
      lightboxImage.src = '';
      document.body.style.overflow = '';
    };

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const imageUrl = trigger.dataset.imageUrl;
        const imageAlt = trigger.dataset.imageAlt;
        openLightbox(imageUrl, imageAlt);
      });
    });

    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeLightbox);
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
(function() {
  const popup = document.querySelector('[data-popup]');
  if (!popup) return;

  const sectionId = popup.closest('.shopify-section')?.id || popup.dataset.popupId;
  let delayTimeoutId = null;
  let countdownIntervalId = null;
  let exitIntentHandler = null;
  let scrollHandler = null;
  let clickHandlers = [];
  let closeHandlers = [];
  let escapeHandler = null;

  function init() {
    const trigger = popup.dataset.trigger;
    const triggerDelay = parseInt(popup.dataset.triggerDelay, 10) * 1000;
    const triggerScroll = parseInt(popup.dataset.triggerScroll, 10);
    const showOnce = popup.dataset.showOnce === 'true';
    const showOnceDays = parseInt(popup.dataset.showOnceDays, 10);
    const popupId = popup.dataset.popupId;
    const storageKey = `popup_dismissed_${popupId}`;

    // Check if already dismissed
    if (showOnce) {
      const dismissedAt = localStorage.getItem(storageKey);
      if (dismissedAt) {
        const dismissedDate = new Date(parseInt(dismissedAt, 10));
        const now = new Date();
        const daysSince = (now - dismissedDate) / (1000 * 60 * 60 * 24);
        if (daysSince < showOnceDays) {
          return;
        }
      }
    }

    // Focus trap variables
    let previouslyFocusedElement = null;
    let focusTrapHandler = null;

    const getFocusableElements = () => {
      const container = popup.querySelector('.popup__container');
      return container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    };

    const trapFocus = (e) => {
      const focusable = getFocusableElements();
      if (focusable.length === 0) return;

      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    };

    const showPopup = () => {
      previouslyFocusedElement = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';

      // Set up focus trap
      focusTrapHandler = (e) => {
        if (e.key === 'Tab') {
          trapFocus(e);
        }
      };
      document.addEventListener('keydown', focusTrapHandler);

      // Focus first focusable element
      setTimeout(() => {
        const focusable = getFocusableElements();
        if (focusable.length > 0) {
          focusable[0].focus();
        }
      }, 50);
    };

    const hidePopup = () => {
      popup.hidden = true;
      document.body.style.overflow = '';
      if (showOnce) {
        localStorage.setItem(storageKey, Date.now().toString());
      }

      // Remove focus trap
      if (focusTrapHandler) {
        document.removeEventListener('keydown', focusTrapHandler);
        focusTrapHandler = null;
      }

      // Return focus to trigger element
      if (previouslyFocusedElement && previouslyFocusedElement.focus) {
        previouslyFocusedElement.focus();
      }
    };

    // Trigger handlers
    if (trigger === 'load') {
      delayTimeoutId = setTimeout(showPopup, triggerDelay);
    } else if (trigger === 'exit') {
      let shown = false;
      exitIntentHandler = (e) => {
        if (!shown && e.clientY < 10 && e.relatedTarget === null) {
          shown = true;
          showPopup();
        }
      };
      document.addEventListener('mouseout', exitIntentHandler);
    } else if (trigger === 'scroll') {
      let shown = false;
      scrollHandler = () => {
        if (shown) return;
        const scrollPercent = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent >= triggerScroll) {
          shown = true;
          showPopup();
        }
      };
      window.addEventListener('scroll', scrollHandler);
    } else if (trigger === 'click') {
      document.querySelectorAll('[data-popup-trigger="' + popupId + '"]').forEach(el => {
        const handler = (e) => {
          e.preventDefault();
          showPopup();
        };
        el.addEventListener('click', handler);
        clickHandlers.push({ el, handler });
      });
    }

    // Close handlers
    popup.querySelectorAll('[data-popup-close]').forEach(el => {
      const handler = () => hidePopup();
      el.addEventListener('click', handler);
      closeHandlers.push({ el, handler });
    });

    // ESC key
    escapeHandler = (e) => {
      if (e.key === 'Escape' && !popup.hidden) {
        hidePopup();
      }
    };
    document.addEventListener('keydown', escapeHandler);

    // Countdown
    const countdown = popup.querySelector('[data-popup-countdown]');
    if (countdown) {
      const targetDate = new Date(countdown.dataset.targetDate).getTime();
      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');

      const pad = (n) => String(n).padStart(2, '0');

      const update = () => {
        const now = Date.now();
        const distance = targetDate - now;

        if (distance <= 0) {
          countdown.style.display = 'none';
          if (countdownIntervalId) {
            clearInterval(countdownIntervalId);
            countdownIntervalId = null;
          }
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      };

      update();
      countdownIntervalId = setInterval(update, 1000);
    }
  }

  function cleanup() {
    if (delayTimeoutId) {
      clearTimeout(delayTimeoutId);
      delayTimeoutId = null;
    }
    if (countdownIntervalId) {
      clearInterval(countdownIntervalId);
      countdownIntervalId = null;
    }
    if (exitIntentHandler) {
      document.removeEventListener('mouseout', exitIntentHandler);
      exitIntentHandler = null;
    }
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    clickHandlers.forEach(({ el, handler }) => {
      el.removeEventListener('click', handler);
    });
    clickHandlers = [];
    closeHandlers.forEach(({ el, handler }) => {
      el.removeEventListener('click', handler);
    });
    closeHandlers = [];
    if (escapeHandler) {
      document.removeEventListener('keydown', escapeHandler);
      escapeHandler = null;
    }
    if (focusTrapHandler) {
      document.removeEventListener('keydown', focusTrapHandler);
      focusTrapHandler = null;
    }
    // Reset popup state
    popup.hidden = true;
    document.body.style.overflow = '';
  }

  init();

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === sectionId) {
      cleanup();
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const instanceRegistry = new Map();

    function initProductCarousel(section) {
      const track = section.querySelector('[data-carousel-track]');
      const prevBtn = section.querySelector('[data-carousel-prev]');
      const nextBtn = section.querySelector('[data-carousel-next]');
      const isAutoplay = section.hasAttribute('data-autoplay');

      if (!track) return;

      const instance = {
        autoplayInterval: null,
        handlers: []
      };

      const getScrollAmount = () => {
        const item = track.querySelector('.product-carousel__item');
        if (!item) return 300;
        const gap = parseFloat(getComputedStyle(track).gap) || 24;
        return item.offsetWidth + gap;
      };

      const updateNavState = () => {
        if (!prevBtn || !nextBtn) return;
        const isAtStart = track.scrollLeft <= 1;
        const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = isAtStart;
        nextBtn.disabled = isAtEnd;
      };

      if (prevBtn && nextBtn) {
        const handlePrev = () => track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        const handleNext = () => track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });

        prevBtn.addEventListener('click', handlePrev);
        nextBtn.addEventListener('click', handleNext);
        track.addEventListener('scroll', updateNavState);

        instance.handlers.push(
          { el: prevBtn, event: 'click', fn: handlePrev },
          { el: nextBtn, event: 'click', fn: handleNext },
          { el: track, event: 'scroll', fn: updateNavState }
        );

        updateNavState();
      }

      if (isAutoplay && prevBtn && nextBtn) {
        const speed = parseInt(getComputedStyle(section).getPropertyValue('--autoplay-speed')) || 4000;

        const startAutoplay = () => {
          instance.autoplayInterval = setInterval(() => {
            const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
            if (isAtEnd) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            }
          }, speed);
        };

        const stopAutoplay = () => {
          clearInterval(instance.autoplayInterval);
        };

        section.addEventListener('mouseenter', stopAutoplay);
        section.addEventListener('mouseleave', startAutoplay);
        section.addEventListener('focusin', stopAutoplay);
        section.addEventListener('focusout', startAutoplay);

        instance.handlers.push(
          { el: section, event: 'mouseenter', fn: stopAutoplay },
          { el: section, event: 'mouseleave', fn: startAutoplay },
          { el: section, event: 'focusin', fn: stopAutoplay },
          { el: section, event: 'focusout', fn: startAutoplay }
        );

        startAutoplay();
      }

      instanceRegistry.set(section.id, instance);
    }

    function destroyProductCarousel(sectionId) {
      const instance = instanceRegistry.get(sectionId);
      if (!instance) return;

      if (instance.autoplayInterval) {
        clearInterval(instance.autoplayInterval);
      }

      instance.handlers.forEach(({ el, event, fn }) => {
        el.removeEventListener(event, fn);
      });

      instanceRegistry.delete(sectionId);
    }

    // Initialize all carousels on page load
    document.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);

    // Theme editor support
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-product-carousel]');
      if (section) initProductCarousel(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-product-carousel]');
      if (section) destroyProductCarousel(section.id);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function() {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const form = section.querySelector('[data-product-form]');
  const variantInput = form ? form.querySelector('[data-variant-id]') : null;
  const qtyInput = section.querySelector('[data-qty-input]');
  const decreaseBtn = section.querySelector('[data-qty-decrease]');
  const increaseBtn = section.querySelector('[data-qty-increase]');
  const playsetBtn = section.querySelector('[data-playset-add]');
  const addToCartBtn = section.querySelector('[data-add-to-cart]');
  const priceEl = section.querySelector('[data-product-price]');
  const stockEl = section.querySelector('[data-product-stock]');
  const imageViewer = section.querySelector('[data-image-viewer]');
  // SID-998: the front face, plus its server-rendered src/srcset. The default is
  // restored verbatim (srcset included) so a variant with no art of its own keeps
  // the responsive image Liquid built, rather than a single hand-sized url.
  const frontImg = section.querySelector('.product-image-viewer__face--front img');
  const defaultImgSrc = frontImg ? frontImg.getAttribute('src') : null;
  const defaultImgSrcset = frontImg ? frontImg.getAttribute('srcset') : null;
  const flipBtn = section.querySelector('[data-flip-btn]');
  const variantsJson = section.querySelector('[data-product-variants]');

  let variants = [];
  if (variantsJson) {
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      console.error('Failed to parse variants JSON', e);
    }
  }

  // Per-variant stock, keyed by variant id. Sourced server-side because Shopify
  // strips inventory_quantity from the variant JSON above. Value is the tracked
  // count, or null when inventory isn't tracked.
  const inventoryJson = section.querySelector('[data-variant-inventory]');
  let variantInventory = {};
  if (inventoryJson) {
    try {
      variantInventory = JSON.parse(inventoryJson.textContent);
    } catch (e) {
      console.error('Failed to parse variant inventory JSON', e);
    }
  }

  // Stock for a variant: the tracked count, or null (no stock cap) when the
  // variant's inventory isn't tracked or is unknown.
  function variantStockFor(v) {
    if (!v) return null;
    const s = variantInventory[v.id];
    return s === undefined ? null : s;
  }

  // Card flip functionality
  if (flipBtn && imageViewer) {
    flipBtn.addEventListener('click', () => {
      imageViewer.classList.toggle('product-image-viewer--flipped');
    });
  }

  // Gallery (non-singles: deck boxes, bundles, merch). A large image plus a
  // thumbnail row -- clicking a thumbnail, or the variant swap below, both just
  // point the main <img> at that thumbnail's own resized src, since the variant
  // JSON's featured_image.src and our resized thumbnail src are different URLs
  // for the same file and can't be compared directly.
  const gallery = section.querySelector('[data-gallery]');
  const galleryMainImg = gallery ? gallery.querySelector('[data-gallery-main-img]') : null;
  const galleryThumbs = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
  const galleryDefaultSrc = galleryMainImg ? galleryMainImg.getAttribute('src') : null;

  function showGalleryImage(src) {
    if (!galleryMainImg || !src) return;
    galleryMainImg.removeAttribute('srcset');
    galleryMainImg.setAttribute('src', src);
    galleryThumbs.forEach(thumb => {
      const isSelected = thumb.dataset.imageSrc === src;
      thumb.classList.toggle('product-gallery__thumb--selected', isSelected);
      thumb.setAttribute('aria-pressed', String(isSelected));
    });
  }

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => showGalleryImage(thumb.dataset.imageSrc));
  });

  // Quantity controls
  if (decreaseBtn && qtyInput) {
    decreaseBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value) || 1;
      if (current > 1) {
        qtyInput.value = current - 1;
        updateQuantityButtons();
      }
    });
  }

  if (increaseBtn && qtyInput) {
    increaseBtn.addEventListener('click', () => {
      const current = parseInt(qtyInput.value) || 1;
      const max = parseInt(qtyInput.max) || 99;
      if (current < max) {
        qtyInput.value = current + 1;
        updateQuantityButtons();
      }
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', () => {
      let val = parseInt(qtyInput.value) || 1;
      const min = parseInt(qtyInput.min) || 1;
      const max = parseInt(qtyInput.max) || 99;
      if (val < min) val = min;
      if (val > max) val = max;
      qtyInput.value = val;
      updateQuantityButtons();
    });
  }

  function updateQuantityButtons() {
    if (!qtyInput) return;
    const current = parseInt(qtyInput.value) || 1;
    const min = parseInt(qtyInput.min) || 1;
    const max = parseInt(qtyInput.max) || 99;
    if (decreaseBtn) decreaseBtn.disabled = current <= min;
    if (increaseBtn) increaseBtn.disabled = current >= max;
  }

  // Main form add to cart - uses Cart API
  if (form && addToCartBtn) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantId = variantInput ? variantInput.value : null;
      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) return;

      const originalText = addToCartBtn.textContent;
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      // Use Cart API if available
      if (window.Sideboard && window.Sideboard.cart) {
        try {
          await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: quantity }]);

          addToCartBtn.textContent = 'Added!';
          setTimeout(() => {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 1500);
        } catch (err) {
          console.error('Add to cart failed', err);
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
        }
      } else {
        // Fallback to native form submit
        form.submit();
      }
    });
  }

  // Playset quick add - uses Cart API
  if (playsetBtn && form) {
    playsetBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const size = parseInt(playsetBtn.dataset.playsetSize) || 4;
      const variantId = variantInput ? variantInput.value : null;

      if (!variantId) return;

      // innerHTML, not textContent: the compact label is two spans (visible "+N"
      // + visually-hidden text) and must survive the restore
      const originalContent = playsetBtn.innerHTML;
      playsetBtn.disabled = true;
      playsetBtn.textContent = 'Adding...';

      // Use Cart API if available
      if (window.Sideboard && window.Sideboard.cart) {
        try {
          await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: size }]);

          playsetBtn.textContent = 'Added!';
          setTimeout(() => {
            playsetBtn.innerHTML = originalContent;
            playsetBtn.disabled = false;
          }, 1500);
        } catch (err) {
          console.error('Playset add failed', err);
          playsetBtn.innerHTML = originalContent;
          playsetBtn.disabled = false;
        }
      } else {
        // Fallback: set quantity and submit form
        if (qtyInput) qtyInput.value = size;
        form.submit();
      }
    });
  }

  // Swatch selection - update variant
  const swatches = section.querySelectorAll('[data-swatch] input');
  swatches.forEach(swatch => {
    // SID-995: pass WHICH axis moved, so an impossible combination can snap to a
    // variant that really carries the value the shopper just picked.
    swatch.addEventListener('change', () => {
      updateVariant(swatch.name);
    });
  });

  // Select element changes
  const selects = section.querySelectorAll('[data-option-select]');
  selects.forEach(select => {
    select.addEventListener('change', () => {
      updateVariant(select.name);
    });
  });

  // SID-995: point every control at `target`'s options. Used when the shopper picks
  // a value that cannot coexist with the rest of the current selection.
  function adoptVariantSelection(target) {
    section.querySelectorAll('input[name^="option"]').forEach(input => {
      const wanted = target[input.name];
      if (wanted === undefined) return;
      if (input.type === 'radio') {
        input.checked = input.value === wanted;
      } else {
        input.value = wanted;
      }
    });
    section.querySelectorAll('select[data-option-select]').forEach(select => {
      const wanted = target[select.name];
      if (wanted !== undefined) select.value = wanted;
    });
  }

  function updateVariant(changedName) {
    // Collect every selected option keyed by position — controls are named option{N}
    // where N is the option's position. Condition/finish can sit at any position, and
    // the app has published single-"Title" products with combined values; matching on
    // only the controls that exist avoids the old wildcard bug where null reads made
    // variants.find() return variants[0] forever. Radios only contribute when checked
    // (unchecked siblings would otherwise overwrite the selected value); a hidden input
    // (a group not shown as a visible control) always contributes its fixed value, same
    // as a select.
    const selected = {};
    section.querySelectorAll('input[name^="option"]').forEach(input => {
      if (input.type === 'radio') {
        if (input.checked) selected[input.name] = input.value;
      } else {
        selected[input.name] = input.value;
      }
    });
    section.querySelectorAll('select[data-option-select]').forEach(select => {
      selected[select.name] = select.value;
    });
    const selectedNames = Object.keys(selected);
    if (!selectedNames.length) return;

    const conditionPos = section.dataset.conditionPosition;
    const finishPos = section.dataset.finishPosition;
    const conditionValue = conditionPos ? selected['option' + conditionPos] : null;
    const finishValue = finishPos ? selected['option' + finishPos] : null;

    // Holo-foil: intensify the shimmer when a Foil finish is selected (for combined
    // single-option products foil-ness lives in the condition value itself)
    if (window.HoloFoil) {
      const holoStage = section.querySelector('[data-holo-viewer]');
      const foilSource = (finishValue || conditionValue || '').toLowerCase();
      if (holoStage) window.HoloFoil.setFoil(holoStage, foilSource.includes('foil') && !foilSource.includes('non-foil'));
    }

    let variant = variants.find(v => selectedNames.every(name => v[name] === selected[name]));

    // 🔴 SID-995. A store can stock a card in Japanese in ONE finish only, so
    // "Normal + Japanese" may be a combination that does not exist. This used to
    // leave the previous variant id in the form: the page showed the ENGLISH price
    // and the ENGLISH stock with "Japanese" selected, Add to cart stayed enabled,
    // and the buyer received the English card. Measured live on Suplex.
    //
    // The upper axes are deliberately never disabled — disabling "Japanese"
    // whenever the current finish lacks it would make the Japanese card
    // unreachable, which is worse. Instead, picking a value the rest of the
    // selection cannot satisfy SNAPS the other axes to a variant that really
    // carries it.
    if (!variant && changedName && selected[changedName] !== undefined) {
      const snapTo = variants.find(v => v[changedName] === selected[changedName] && v.available) ||
                     variants.find(v => v[changedName] === selected[changedName]);
      if (snapTo) {
        adoptVariantSelection(snapTo);
        section.querySelectorAll('input[name^="option"]').forEach(input => {
          if (input.type === 'radio') {
            if (input.checked) selected[input.name] = input.value;
          } else {
            selected[input.name] = input.value;
          }
        });
        section.querySelectorAll('select[data-option-select]').forEach(select => {
          selected[select.name] = select.value;
        });
        variant = variants.find(v => Object.keys(selected).every(name => v[name] === selected[name]));
      }
    }

    // SID-998: show the card the shopper actually selected.
    //
    // A store stocking one card in English AND Japanese has ONE listing with one
    // picture, so picking "Japanese" used to leave the English art on screen — a
    // buyer paying for a Japanese card while looking at an English one.
    //
    // 🔴 A null `featured_image` is NOT a missing picture. It means "this variant
    // uses the product default", which is how the English variants stay right
    // without binding a file to every one of them. Falling back to the captured
    // default is what makes that work.
    if (frontImg) {
      const variantImage = variant && variant.featured_image && variant.featured_image.src;
      if (variantImage) {
        // srcset would otherwise win over src and keep the old picture on screen.
        frontImg.removeAttribute('srcset');
        frontImg.setAttribute('src', variantImage + (variantImage.indexOf('?') === -1 ? '?' : '&') + 'width=1200');
      } else if (defaultImgSrc) {
        if (defaultImgSrcset) {
          frontImg.setAttribute('srcset', defaultImgSrcset);
        } else {
          frontImg.removeAttribute('srcset');
        }
        frontImg.setAttribute('src', defaultImgSrc);
      }
    }

    // Same idea for the non-single gallery, matched by image id (not src -- see
    // showGalleryImage above) since a variant with no image of its own should
    // leave the product's default image showing, exactly like the card case.
    if (gallery) {
      const variantImageId = variant && variant.featured_image && variant.featured_image.id;
      const matchingThumb = variantImageId != null
        ? galleryThumbs.find(thumb => thumb.dataset.imageId === String(variantImageId))
        : null;
      showGalleryImage(matchingThumb ? matchingThumb.dataset.imageSrc : galleryDefaultSrc);
    }

    if (variant && variantInput) {
      variantInput.value = variant.id;

      // Update URL without page reload
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update price display
      if (priceEl) {
        const priceCurrentEl = priceEl.querySelector('[data-price-current]');
        if (priceCurrentEl) {
          const price = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : '$' + (variant.price / 100).toFixed(2);
          priceCurrentEl.textContent = price;

          // Update sale styling
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCurrentEl.classList.add('product-section__price-current--sale');
          } else {
            priceCurrentEl.classList.remove('product-section__price-current--sale');
          }
        }
      }

      // Update stock display (same rules as the Liquid render: hidden when sold out,
      // exact count at 1-10, generic "In stock" above that or when untracked)
      if (stockEl) {
        const stock = variantStockFor(variant);
        if (!variant.available) {
          stockEl.style.display = 'none';
        } else if (stock != null && stock > 0 && stock <= 10) {
          stockEl.textContent = stock + ' in stock';
          stockEl.style.display = '';
        } else {
          stockEl.textContent = 'In stock';
          stockEl.style.display = '';
        }
      }

      // Update max quantity to the SELECTED variant's stock (lower of stock and
      // the per-order purchase limit). Runs on every variant change. Stock comes
      // from variantStockFor (server-rendered) because inventory_quantity is
      // stripped from the variant JSON; null = untracked → no stock cap.
      if (qtyInput) {
        const stock = variantStockFor(variant);
        const perOrderLimit = parseInt(qtyInput.getAttribute('data-max-per-order'), 10) || 0;
        let effectiveMax = (stock != null && stock > 0) ? stock : 99;
        if (perOrderLimit > 0 && perOrderLimit < effectiveMax) {
          effectiveMax = perOrderLimit;
        }
        qtyInput.max = effectiveMax;
        if (parseInt(qtyInput.value) > effectiveMax) {
          qtyInput.value = effectiveMax;
        }
        updateQuantityButtons();
      }

      // Update add to cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
        }
      }

      // Update playset button visibility
      if (playsetBtn) {
        const playsetSize = parseInt(playsetBtn.dataset.playsetSize) || 4;
        const qty = variantStockFor(variant);
        const hasEnoughStock = (qty == null && variant.available) || (qty != null && qty >= playsetSize);
        playsetBtn.style.display = hasEnoughStock ? '' : 'none';
      }
    } else if (variantInput) {
      // Full current selection matches no variant -- never leave a mismatched
      // variant id sitting in the form. Clear it, drop price/stock, and disable
      // Add to Cart until the shopper picks a combination that actually exists.
      variantInput.value = '';

      if (priceEl) {
        const priceCurrentEl = priceEl.querySelector('[data-price-current]');
        if (priceCurrentEl) priceCurrentEl.textContent = '';
      }
      if (stockEl) stockEl.style.display = 'none';
      if (addToCartBtn) addToCartBtn.disabled = true;
      if (playsetBtn) playsetBtn.style.display = 'none';
    }

    updateOptionAvailability(selected);
  }

  // For every option group, recompute two things per value against the CURRENT
  // full selection, kept deliberately separate (SID-995 follow-up review):
  //
  //   globally available -- does ANY variant carry this value at all, regardless
  //     of every other axis? This is the only thing allowed to disable a control.
  //     A value some variant stocks must stay clickable no matter what else is
  //     picked, or a genuinely in-stock card (Japanese, Foil only) becomes
  //     unreachable.
  //
  //   compatible -- does it also match the CURRENTLY selected value of every
  //     other group (and, for the Condition group, what's its stock under that
  //     match)? Drives the struck-through/dimmed visual and the stock badge, but
  //     never disables.
  //
  // Mirrors the server-rendered pass above and runs after every chip/select
  // change, so both states stay in sync with what the shopper just picked.
  function updateOptionAvailability(selected) {
    const optionNames = Object.keys(selected);

    section.querySelectorAll('[data-option-group]').forEach(group => {
      const position = group.dataset.optionGroup;
      const name = 'option' + position;
      const isConditionGroup = position === section.dataset.conditionPosition;

      group.querySelectorAll('[data-swatch]').forEach(swatch => {
        const value = swatch.dataset.optionValue;
        let globallyAvailable = false;
        let compatible = false;
        let stock = 0;
        variants.forEach(v => {
          if (v[name] !== value) return;
          if (v.available) globallyAvailable = true;
          const matchesOthers = optionNames.every(otherName => otherName === name || v[otherName] === selected[otherName]);
          if (matchesOthers && v.available) {
            compatible = true;
            const vStock = variantStockFor(v);
            if (vStock != null && vStock > 0) stock += vStock;
          }
        });

        const input = swatch.querySelector('input');
        const isChecked = input && input.checked;
        swatch.classList.toggle('product-section__swatch--unavailable', !compatible);
        // Never disable the currently checked radio -- it stays selectable (shown
        // struck through by the class above) so the shopper can always switch off it.
        if (input && !isChecked) input.disabled = !globallyAvailable;

        if (isConditionGroup) {
          swatch.dataset.conditionStock = stock;
          const stockBadge = swatch.querySelector('[data-condition-stock-badge]');
          if (stock > 0 && stock <= 10) {
            if (stockBadge) {
              stockBadge.textContent = '(' + stock + ')';
              stockBadge.style.display = '';
            } else {
              const label = swatch.querySelector('.product-section__swatch-label');
              if (label) {
                const newBadge = document.createElement('span');
                newBadge.className = 'product-section__swatch-stock';
                newBadge.dataset.conditionStockBadge = '';
                newBadge.textContent = '(' + stock + ')';
                label.appendChild(newBadge);
              }
            }
          } else if (stockBadge) {
            stockBadge.style.display = 'none';
          }
        }
      });
    });

    // Dropdown mode: a disabled <option> can't be chosen by the shopper, so only
    // global availability may disable one there too. The currently selected
    // option is never disabled, matching the swatch rule above.
    section.querySelectorAll('[data-option-select]').forEach(select => {
      const name = select.name;
      Array.from(select.options).forEach(opt => {
        if (opt.value === select.value) {
          opt.disabled = false;
          return;
        }
        let globallyAvailable = false;
        let compatible = false;
        variants.forEach(v => {
          if (v[name] !== opt.value) return;
          if (v.available) globallyAvailable = true;
          const matchesOthers = optionNames.every(otherName => otherName === name || v[otherName] === selected[otherName]);
          if (matchesOthers && v.available) compatible = true;
        });
        opt.disabled = !globallyAvailable;
        opt.style.textDecoration = compatible ? '' : 'line-through';
      });
    });
  }

  // ========== TABLE MODE FUNCTIONALITY ==========
  const variantRows = section.querySelectorAll('[data-variant-row]');

  if (variantRows.length > 0) {
    variantRows.forEach(row => {
      const variantId = row.dataset.variantId;
      const variantStock = parseInt(row.dataset.variantStock) || 0;
      const isAvailable = row.dataset.variantAvailable === 'true';

      const qtyInput = row.querySelector('[data-table-qty-input]');
      const decreaseBtn = row.querySelector('[data-table-qty-decrease]');
      const increaseBtn = row.querySelector('[data-table-qty-increase]');
      const addBtn = row.querySelector('[data-table-add-to-cart]');
      const playsetBtn = row.querySelector('[data-table-playset-add]');

      // Initialize quantity buttons state
      function updateRowQtyButtons() {
        if (!qtyInput) return;
        const current = parseInt(qtyInput.value) || 1;
        const min = parseInt(qtyInput.min) || 1;
        const max = parseInt(qtyInput.max) || variantStock;
        if (decreaseBtn) decreaseBtn.disabled = current <= min;
        if (increaseBtn) increaseBtn.disabled = current >= max;
      }

      // Quantity decrease
      if (decreaseBtn && qtyInput) {
        decreaseBtn.addEventListener('click', () => {
          const current = parseInt(qtyInput.value) || 1;
          if (current > 1) {
            qtyInput.value = current - 1;
            updateRowQtyButtons();
          }
        });
      }

      // Quantity increase
      if (increaseBtn && qtyInput) {
        increaseBtn.addEventListener('click', () => {
          const current = parseInt(qtyInput.value) || 1;
          const max = parseInt(qtyInput.max) || variantStock;
          if (current < max) {
            qtyInput.value = current + 1;
            updateRowQtyButtons();
          }
        });
      }

      // Quantity input change
      if (qtyInput) {
        qtyInput.addEventListener('change', () => {
          let val = parseInt(qtyInput.value) || 1;
          const min = parseInt(qtyInput.min) || 1;
          const max = parseInt(qtyInput.max) || variantStock;
          if (val < min) val = min;
          if (val > max) val = max;
          qtyInput.value = val;
          updateRowQtyButtons();
        });
        updateRowQtyButtons();
      }

      // Add to Cart button - uses Cart API
      if (addBtn && isAvailable) {
        addBtn.addEventListener('click', async () => {
          const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          const originalText = addBtn.textContent;

          addBtn.disabled = true;
          addBtn.textContent = '...';

          // Use Cart API if available
          if (window.Sideboard && window.Sideboard.cart) {
            try {
              await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: quantity }]);

              addBtn.textContent = 'Added!';
              addBtn.classList.add('product-section__table-add-btn--added');

              setTimeout(() => {
                addBtn.textContent = originalText;
                addBtn.classList.remove('product-section__table-add-btn--added');
                addBtn.disabled = false;
              }, 1500);
            } catch (err) {
              console.error('Table add to cart failed', err);
              addBtn.textContent = 'Error';
              setTimeout(() => {
                addBtn.textContent = originalText;
                addBtn.disabled = false;
              }, 1500);
            }
          } else {
            // Fallback to direct fetch
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
              });

              if (response.ok) {
                addBtn.textContent = 'Added!';
                addBtn.classList.add('product-section__table-add-btn--added');
                document.dispatchEvent(new CustomEvent('cart:updated'));

                setTimeout(() => {
                  addBtn.textContent = originalText;
                  addBtn.classList.remove('product-section__table-add-btn--added');
                  addBtn.disabled = false;
                }, 1500);
              } else {
                throw new Error('Add to cart failed');
              }
            } catch (err) {
              console.error('Table add to cart failed', err);
              addBtn.textContent = 'Error';
              setTimeout(() => {
                addBtn.textContent = originalText;
                addBtn.disabled = false;
              }, 1500);
            }
          }
        });
      }

      // Playset button - uses Cart API
      if (playsetBtn && isAvailable) {
        playsetBtn.addEventListener('click', async () => {
          const size = parseInt(playsetBtn.dataset.playsetSize) || 4;
          const originalText = playsetBtn.textContent;

          playsetBtn.disabled = true;
          playsetBtn.textContent = '...';

          // Use Cart API if available
          if (window.Sideboard && window.Sideboard.cart) {
            try {
              await window.Sideboard.cart.add([{ id: parseInt(variantId), quantity: size }]);

              playsetBtn.textContent = 'Added!';
              playsetBtn.classList.add('product-section__table-playset-btn--added');

              setTimeout(() => {
                playsetBtn.textContent = originalText;
                playsetBtn.classList.remove('product-section__table-playset-btn--added');
                playsetBtn.disabled = false;
              }, 1500);
            } catch (err) {
              console.error('Table playset add failed', err);
              playsetBtn.textContent = 'Error';
              setTimeout(() => {
                playsetBtn.textContent = originalText;
                playsetBtn.disabled = false;
              }, 1500);
            }
          } else {
            // Fallback to direct fetch
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: size }] })
              });

              if (response.ok) {
                playsetBtn.textContent = 'Added!';
                playsetBtn.classList.add('product-section__table-playset-btn--added');
                document.dispatchEvent(new CustomEvent('cart:updated'));

                setTimeout(() => {
                  playsetBtn.textContent = originalText;
                  playsetBtn.classList.remove('product-section__table-playset-btn--added');
                  playsetBtn.disabled = false;
                }, 1500);
              } else {
                throw new Error('Playset add failed');
              }
            } catch (err) {
              console.error('Table playset add failed', err);
              playsetBtn.textContent = 'Error';
              setTimeout(() => {
                playsetBtn.textContent = originalText;
                playsetBtn.disabled = false;
              }, 1500);
            }
          }
        });
      }
    });
  }

  // Initialize
  updateQuantityButtons();

  // ========== TABBED DESCRIPTION FUNCTIONALITY ==========
  const descriptionTabs = section.querySelector('[data-description-tabs]');

  if (descriptionTabs) {
    const tabButtons = descriptionTabs.querySelectorAll('[data-tab-btn]');
    const tabPanels = descriptionTabs.querySelectorAll('[data-tab-panel]');

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetTab = button.dataset.tabBtn;

        // Update buttons
        tabButtons.forEach(btn => {
          btn.classList.remove('product-section__tab-btn--active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('product-section__tab-btn--active');
        button.setAttribute('aria-selected', 'true');

        // Update panels
        tabPanels.forEach(panel => {
          if (panel.dataset.tabPanel === targetTab) {
            panel.classList.add('product-section__tab-panel--active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('product-section__tab-panel--active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  // ========== RECENTLY VIEWED FUNCTIONALITY ==========
  // v2: bumped to invalidate entries cached with phantom $0 prices before the
  // cheapest-variant price fix shipped.
  const STORAGE_KEY = 'sideboard_recently_viewed_v2';
  const MAX_STORED = 10;
  const recentlyViewedSection = section.querySelector('[data-recently-viewed-section]');
  const recentlyViewedGrid = section.querySelector('[data-recently-viewed-grid]');
  const currentProductJson = section.querySelector('[data-current-product]');

  if (currentProductJson && recentlyViewedSection && recentlyViewedGrid) {
    try {
      const currentProduct = JSON.parse(currentProductJson.textContent);

      // Save current product to localStorage
      saveToRecentlyViewed(currentProduct);

      // Render recently viewed products
      renderRecentlyViewed(currentProduct.handle);
    } catch (e) {
      console.error('Recently Viewed: Failed to process product data', e);
    }
  }

  function saveToRecentlyViewed(product) {
    try {
      let recentlyViewed = getRecentlyViewed();

      // Remove product if it already exists (to move it to front)
      recentlyViewed = recentlyViewed.filter(function(p) { return p.handle !== product.handle; });

      // Add current product to the front
      recentlyViewed.unshift({
        handle: product.handle,
        title: product.title,
        url: product.url,
        price: product.price,
        compare_at_price: product.compare_at_price,
        available: product.available,
        featured_image: product.featured_image,
        is_single: product.is_single
      });

      // Keep only the last MAX_STORED products
      if (recentlyViewed.length > MAX_STORED) {
        recentlyViewed = recentlyViewed.slice(0, MAX_STORED);
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));
    } catch (e) {
      console.error('Recently Viewed: Failed to save to localStorage', e);
    }
  }

  function getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Recently Viewed: Failed to read from localStorage', e);
      return [];
    }
  }

  function renderRecentlyViewed(currentHandle) {
    const recentlyViewed = getRecentlyViewed();

    // Filter out current product
    var productsToShow = recentlyViewed.filter(function(p) { return p.handle !== currentHandle; });

    // Get max count from data attribute (default to 4)
    var maxCount = parseInt(recentlyViewedSection.dataset.maxCount, 10) || 4;
    var limitedProducts = productsToShow.slice(0, maxCount);

    // Hide section if no products to show
    if (limitedProducts.length === 0) {
      recentlyViewedSection.style.display = 'none';
      return;
    }

    // Show section and render products using safe DOM methods
    recentlyViewedSection.style.display = '';
    recentlyViewedGrid.innerHTML = ''; // Clear existing content

    limitedProducts.forEach(function(product) {
      var card = createProductCard(product);
      recentlyViewedGrid.appendChild(card);
    });
  }

  // Build the canonical product-card markup (mirrors snippets/product-card.liquid)
  // so the Recently Viewed rail renders the same card as Related and the grids.
  // Display-only: no data-product-card attribute, so the quick-add IIFE in the
  // snippet leaves these inert. Styling is class-based, so they look identical.
  function createProductCard(product) {
    const isSale = product.compare_at_price && product.compare_at_price > product.price;

    const card = document.createElement('article');
    card.className = 'product-card';

    // Media (image + badges)
    const media = document.createElement('div');
    media.className = 'product-card__media';
    // Entries saved before this shipped have no is_single field; treat that as a
    // single (the prior behavior) rather than guessing, so old localStorage data
    // still renders instead of erroring.
    if (product.is_single === false) {
      media.classList.add('product-card__media--contain');
    }

    const imageWrapper = document.createElement('a');
    imageWrapper.className = 'product-card__image-wrapper';
    imageWrapper.href = product.url;

    if (product.featured_image) {
      const img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title;
      img.className = 'product-card__image';
      img.loading = 'lazy';
      // Intrinsic TCG card ratio so the slot reserves space before the lazy image
      // loads — otherwise the card collapses to 0 width.
      img.width = 63;
      img.height = 88;
      imageWrapper.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'product-card__placeholder';
      // Same decorative SVG as the snippet's placeholder (static markup, no data).
      placeholder.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" rx="4" fill="currentColor" opacity="0.1"/><path d="M18 30L24 24L30 30" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/><circle cx="32" cy="18" r="3" stroke="currentColor" stroke-width="2" opacity="0.4"/></svg>';
      imageWrapper.appendChild(placeholder);
    }

    media.appendChild(imageWrapper);

    if (isSale || !product.available) {
      const badges = document.createElement('div');
      badges.className = 'product-card__badges';
      if (isSale) {
        const sale = document.createElement('span');
        sale.className = 'product-card__badge product-card__badge--sale';
        sale.textContent = 'Sale';
        badges.appendChild(sale);
      }
      if (!product.available) {
        const soldout = document.createElement('span');
        soldout.className = 'product-card__badge product-card__badge--soldout';
        soldout.textContent = 'Sold out';
        badges.appendChild(soldout);
      }
      media.appendChild(badges);
    }

    card.appendChild(media);

    // Info (title + price)
    const info = document.createElement('div');
    info.className = 'product-card__info';

    const titleLink = document.createElement('a');
    titleLink.className = 'product-card__title-link';
    titleLink.href = product.url;
    const title = document.createElement('h2');
    title.className = 'product-card__title';
    title.textContent = product.title;
    titleLink.appendChild(title);
    info.appendChild(titleLink);

    const priceWrapper = document.createElement('div');
    priceWrapper.className = 'product-card__price';
    if (isSale) {
      const comparePrice = document.createElement('span');
      comparePrice.className = 'product-card__price-compare';
      comparePrice.textContent = formatPrice(product.compare_at_price);
      priceWrapper.appendChild(comparePrice);
    }
    const currentPrice = document.createElement('span');
    currentPrice.className = 'product-card__price-current' + (isSale ? ' product-card__price-current--sale' : '');
    currentPrice.textContent = formatPrice(product.price);
    priceWrapper.appendChild(currentPrice);
    info.appendChild(priceWrapper);

    card.appendChild(info);

    return card;
  }

  function formatPrice(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }
})();

// Sell Us This Card — reveal the button only if this store runs a buylist for the
// card's game. The button ships hidden; we probe the app proxy (?format=json) which
// answers authoritatively, then unhide on success. Availability is per-game, so it's
// cached for the session; on any failure the button stays hidden (no dead-ends).
(function initSellButtons() {
  var buttons = document.querySelectorAll('.product-section__buylist-btn[hidden]');
  Array.prototype.forEach.call(buttons, function (btn) {
    var href = btn.getAttribute('href');
    if (!href) return;

    var game = btn.getAttribute('data-buylist-game') || '';
    var cacheKey = 'sb-buylist-avail:' + game;

    var cached = null;
    try { cached = sessionStorage.getItem(cacheKey); } catch (e) {}
    if (cached === 'yes') { btn.removeAttribute('hidden'); return; }
    if (cached === 'no') { return; }

    var probe;
    try { probe = new URL(href, window.location.origin); } catch (e) { return; }
    probe.searchParams.set('format', 'json');

    fetch(probe.toString(), { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return;
        var available = !!data.available;
        try { sessionStorage.setItem(cacheKey, available ? 'yes' : 'no'); } catch (e) {}
        if (available) btn.removeAttribute('hidden');
      })
      .catch(function () { /* network/parse failure: leave hidden */ });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  var searchSection = document.querySelector('.search-section');
  if (!searchSection) return;

  // Sort dropdown
  var sortSelect = searchSection.querySelector('[data-search-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // In Stock filter — toggles Shopify's native availability filter. The checked
  // state (and the value carried across a re-search) is read from the URL here in
  // JS, since Liquid can't read query-string params. Checked = in-stock only (=1);
  // unchecked sets =0,1 ("show all") so the choice is always explicit in the URL.
  var inStockToggle = searchSection.querySelector('[data-search-instock]');
  if (inStockToggle) {
    var availParam = new URLSearchParams(window.location.search).get('filter.v.availability');
    inStockToggle.checked = availParam === '1';
    inStockToggle.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('filter.v.availability', this.checked ? '1' : '0,1');
      window.location.href = url.toString();
    });
    // Carry the current availability into a re-search so a new query keeps the
    // shopper's in/out-of-stock view (absent stays unconstrained).
    var searchForm = searchSection.querySelector('.search__form');
    if (searchForm && availParam) {
      var carried = document.createElement('input');
      carried.type = 'hidden';
      carried.name = 'filter.v.availability';
      carried.value = availParam;
      searchForm.appendChild(carried);
    }
  }

  // View mode toggle
  var STORAGE_KEY = 'sideboard-search-view';
  var searchGrid = searchSection.querySelector('[data-search-grid]');
  var viewToggleBtns = searchSection.querySelectorAll('[data-view-toggle]');

  if (searchGrid && viewToggleBtns.length > 0) {
    var defaultView = searchGrid.dataset.defaultView || 'grid';

    function getSavedView() {
      try {
        var saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'grid' || saved === 'list') {
          return saved;
        }
      } catch (e) {}
      return defaultView;
    }

    function saveView(view) {
      try {
        localStorage.setItem(STORAGE_KEY, view);
      } catch (e) {}
    }

    function setViewMode(view) {
      searchGrid.dataset.viewMode = view;
      viewToggleBtns.forEach(function(btn) {
        var btnView = btn.dataset.viewToggle;
        btn.setAttribute('aria-pressed', btnView === view ? 'true' : 'false');
      });
      saveView(view);
    }

    // Initialize from saved preference
    setViewMode(getSavedView());

    // Handle toggle clicks
    viewToggleBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setViewMode(btn.dataset.viewToggle);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar"] && !Shopify.designMode) return;
  try {
    
// Mark which link in the current set is the view you're on. Liquid renders
// "View all" as active for an unfiltered collection page (works with no JS);
// this moves the mark onto the applied filter's link instead.
//
// It has to run client-side: Shopify exposes no query string to Liquid, so the
// server can't see `filter.p.tag` — and collection filtering is AJAX +
// pushState, so a server-rendered class would go stale the moment a shopper
// toggles a filter without a page load. Hence the collection:updated /
// popstate re-syncs (the same events the filter sidebar refreshes itself on).
(function () {
  function syncActiveSetLink() {
    var applied = new URLSearchParams(window.location.search).getAll('filter.p.tag');

    // Only the set for the collection being viewed can have an active link;
    // Liquid stamps it. querySelectorAll, since the same collection may appear
    // in more than one Sets block.
    document.querySelectorAll('[data-sidebar-set-active]').forEach(function (group) {
      group.querySelectorAll('[data-sidebar-filter-tag]').forEach(function (link) {
        var on = applied.indexOf(link.dataset.sidebarFilterTag) !== -1;
        link.classList.toggle('sidebar__link--active', on);
        if (on) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      // "View all" is the active one only on an unfiltered view. A filter the
      // sidebar doesn't list (a color, a price band) leaves nothing marked —
      // honest: you're on a view this set can't name.
      var viewAll = group.querySelector('[data-sidebar-view-all]');
      if (!viewAll) return;
      var viewAllOn = applied.length === 0;
      viewAll.classList.toggle('sidebar__link--active', viewAllOn);
      if (viewAllOn) {
        viewAll.setAttribute('aria-current', 'page');
      } else {
        viewAll.removeAttribute('aria-current');
      }
    });
  }

  syncActiveSetLink();
  document.addEventListener('collection:updated', syncActiveSetLink);
  window.addEventListener('popstate', syncActiveSetLink);
})();

(function () {
  var drawer = window.matchMedia('(max-width: 989px)');

  document.querySelectorAll('[data-sidebar]').forEach(function (root) {
    // Drawer behavior only applies to the site-wide rail. A standalone
    // placement is a plain inline nav — nothing to open, close, or trap.
    if (!root.closest('.layout-shell')) return;

    var openBtn = root.querySelector('[data-sidebar-open]');
    var panel = root.querySelector('.sidebar__panel');
    var overlay = root.querySelector('.sidebar__overlay');
    if (!openBtn || !panel) return;

    function isOpen() {
      return root.classList.contains('is-open');
    }

    // Off-canvas links must be unreachable (tab, screen reader) while the
    // drawer is closed. On desktop the panel is always a visible nav, never inert.
    function syncInert() {
      panel.inert = drawer.matches && !isOpen();
    }

    function setOpen(open) {
      root.classList.toggle('is-open', open);
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (overlay) overlay.hidden = !open;
      document.body.style.overflow = open && drawer.matches ? 'hidden' : '';
      syncInert();
      if (open) {
        var close = panel.querySelector('[data-sidebar-close]');
        (close || panel).focus();
      } else {
        openBtn.focus();
      }
    }

    openBtn.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    root.querySelectorAll('[data-sidebar-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    // Crossing the breakpoint (e.g. rotate, resize) resets drawer state so we
    // never leave the page scroll-locked or the panel wrongly inert.
    drawer.addEventListener('change', function () {
      if (!drawer.matches && isOpen()) {
        root.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        if (overlay) overlay.hidden = true;
        document.body.style.overflow = '';
      }
      syncInert();
    });

    syncInert();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('[data-tabs-section]');

  sections.forEach(section => {
    const tabs = section.querySelectorAll('[role="tab"]');
    const panels = section.querySelectorAll('[role="tabpanel"]');

    if (tabs.length === 0) return;

    const activateTab = (index) => {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('tabs__panel--active', isActive);
        panel.setAttribute('aria-hidden', !isActive);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(index);
      });

      // Keyboard navigation
      tab.addEventListener('keydown', (e) => {
        let newIndex;
        if (e.key === 'ArrowRight') {
          newIndex = (index + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabs.length - 1;
        }

        if (newIndex !== undefined) {
          e.preventDefault();
          tabs[newIndex].focus();
          activateTab(newIndex);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcg-brand-logo-strip"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('[data-tcg-logos]');

  sections.forEach(section => {
    const track = section.querySelector('[data-slider-track]');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');
    const isAutoplay = section.hasAttribute('data-autoplay');

    if (!track) return;

    // Get scroll amount (width of one item plus gap)
    const getScrollAmount = () => {
      const item = track.querySelector('.tcg-logos__item');
      if (!item) return 200;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.gap) || 24;
      return item.offsetWidth + gap;
    };

    // Update button states
    const updateNavState = () => {
      if (!prevBtn || !nextBtn) return;

      const isAtStart = track.scrollLeft <= 0;
      const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;

      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
    };

    // Navigation handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNavState);
    updateNavState();

    // Autoplay
    if (isAutoplay) {
      const speed = parseInt(getComputedStyle(section).getPropertyValue('--autoplay-speed')) || 4000;
      let autoplayInterval;

      const startAutoplay = () => {
        autoplayInterval = setInterval(() => {
          const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
          if (isAtEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          }
        }, speed);
      };

      const stopAutoplay = () => {
        clearInterval(autoplayInterval);
      };

      // Pause on hover
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      // Pause on focus (for accessibility)
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);

      startAutoplay();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
